export const portfolioSeoByPath = {
  "/portfolio/anand-sweets": {
    "title": "Anand Sweets Shopify Case Study | Abox Agency",
    "description": "Anand Sweets needed a Shopify store that felt as premium as its mithai. Abox Agency delivered clean UI/UX design and on-site SEO to grow organic orders across India.",
    "url": "https://abox.agency/portfolio/anand-sweets",
    "image": "https://abox.agency/assets/image/og_images/anand_sweets.jpg",
    "keywords": "Anand Sweets, Abox Agency, Shopify development, Indian sweets ecommerce, UI/UX design, on-site SEO, portfolio case study",
    "brand": "Anand Sweets",
    "services": [
      "Shopify",
      "UI/UX Design",
      "SEO"
    ],
    "industry": "Traditional Sweets & Confectionery",
    "schema": {
      "name": "Anand Sweets Portfolio Project",
      "url": "https://abox.agency/portfolio/anand-sweets",
      "description": "Case study for the Anand Sweets ecommerce project covering Shopify, UI/UX Design, and SEO.",
      "image": "https://abox.agency/assets/image/og_images/anand_sweets.jpg",
      "keywords": [
        "Anand Sweets",
        "Shopify",
        "UI/UX Design",
        "SEO"
      ]
    }
  },
  "/portfolio/dr-vaidya": {
    "title": "Dr. Vaidya Shopify Case Study | Abox Agency",
    "description": "Dr. Vaidya sells Ayurvedic stamina and health supplements online. Abox Agency built a Shopify storefront with custom graphics and UI/UX design to build customer trust.",
    "url": "https://abox.agency/portfolio/dr-vaidya",
    "image": "https://abox.agency/assets/image/product/dr_vaidya/product.webp",
    "keywords": "Dr. Vaidya, Abox Agency, Ayurvedic supplements, Shopify store, UI/UX design, graphic design, portfolio case study",
    "brand": "Dr. Vaidya",
    "services": [
      "Shopify",
      "UI/UX Design",
      "Graphic Design"
    ],
    "industry": "Ayurvedic Wellness & Healthcare",
    "schema": {
      "name": "Dr. Vaidya Portfolio Project",
      "url": "https://abox.agency/portfolio/dr-vaidya",
      "description": "Case study for the Dr. Vaidya ecommerce project covering Shopify, UI/UX Design, and Graphic Design.",
      "image": "https://abox.agency/assets/image/product/dr_vaidya/product.webp",
      "keywords": [
        "Dr. Vaidya",
        "Shopify",
        "UI/UX Design",
        "Graphic Design"
      ]
    }
  },
  "/portfolio/yogabar": {
    "title": "Yogabar Shopify Case Study | Abox Agency",
    "description": "Yogabar, a leading protein-food brand, needed a Shopify site that could handle scale. Abox Agency handled UI/UX design, graphic design, and ongoing site maintenance.",
    "url": "https://abox.agency/portfolio/yogabar",
    "image": "https://abox.agency/assets/image/og_images/yogabar.jpg",
    "keywords": "Yogabar, Abox Agency, protein food ecommerce, Shopify development, UI/UX design, site maintenance, portfolio case study",
    "brand": "Yogabar",
    "services": [
      "Shopify",
      "UI/UX Design",
      "Site Maintenance"
    ],
    "industry": "Health Food & Nutrition",
    "schema": {
      "name": "Yogabar Portfolio Project",
      "url": "https://abox.agency/portfolio/yogabar",
      "description": "Case study for the Yogabar ecommerce project covering Shopify, UI/UX Design, and Site Maintenance.",
      "image": "https://abox.agency/assets/image/og_images/yogabar.jpg",
      "keywords": [
        "Yogabar",
        "Shopify",
        "UI/UX Design",
        "Site Maintenance"
      ]
    }
  },
  "/portfolio/chhappanbhog": {
    "title": "Patel's Chhappan Bhog Case Study | Abox Agency",
    "description": "Patel's Chhappan Bhog serves ready-to-eat Indian cuisine nationwide. Abox Agency designed a Shopify store with custom UI/UX and graphics to match its traditional appeal.",
    "url": "https://abox.agency/portfolio/chhappanbhog",
    "image": "https://abox.agency/assets/image/product/chhapanbhog/product.webp",
    "keywords": "Chhappan Bhog, Abox Agency, ready-to-eat Indian food, Shopify development, UI/UX design, graphic design, portfolio case study",
    "brand": "Patel's Chhappan Bhog",
    "services": [
      "Shopify",
      "UI/UX Design",
      "Graphic Design"
    ],
    "industry": "Ready-to-Eat Indian Foods",
    "schema": {
      "name": "Patel's Chhappan Bhog Portfolio Project",
      "url": "https://abox.agency/portfolio/chhappanbhog",
      "description": "Case study for the Patel's Chhappan Bhog ecommerce project covering Shopify, UI/UX Design, and Graphic Design.",
      "image": "https://abox.agency/assets/image/product/chhapanbhog/product.webp",
      "keywords": [
        "Patel's Chhappan Bhog",
        "Shopify",
        "UI/UX Design",
        "Graphic Design"
      ]
    }
  },
  "/portfolio/giver-nutritions": {
    "title": "Giver Nutritions Shopify Case Study | Abox Agency",
    "description": "Giver Nutritions focuses on mental-health supplements. Abox Agency paired Shopify development with branding and on-site SEO to help the label stand out.",
    "url": "https://abox.agency/portfolio/giver-nutritions",
    "image": "https://abox.agency/assets/image/og_images/giver_nutritions.jpg",
    "keywords": "Giver Nutritions, Abox Agency, mental health supplements, Shopify development, branding, on-site SEO, portfolio case study",
    "brand": "Giver Nutritions",
    "services": [
      "Shopify",
      "UI/UX Design",
      "Branding",
      "On-Site SEO"
    ],
    "industry": "Health & Wellness Supplements",
    "schema": {
      "name": "Giver Nutritions Portfolio Project",
      "url": "https://abox.agency/portfolio/giver-nutritions",
      "description": "Case study for the Giver Nutritions ecommerce project covering Shopify, UI/UX Design, Branding, and On-Site SEO.",
      "image": "https://abox.agency/assets/image/og_images/giver_nutritions.jpg",
      "keywords": [
        "Giver Nutritions",
        "Shopify",
        "UI/UX Design",
        "Branding",
        "On-Site SEO"
      ]
    }
  },
  "/portfolio/hyfun": {
    "title": "HyFun Foods Shopify Case Study | Abox Agency",
    "description": "HyFun Foods makes 100% vegetable frozen snacks at scale. Abox Agency built its Shopify presence with fresh branding, UI/UX design, and on-site SEO for D2C growth.",
    "url": "https://abox.agency/portfolio/hyfun",
    "image": "https://abox.agency/assets/image/portfolios/hyfun/hyfun2.webp",
    "keywords": "HyFun Foods, Abox Agency, frozen snacks brand, Shopify store, branding, on-site SEO, portfolio case study",
    "brand": "HyFun Foods",
    "services": [
      "Shopify",
      "UI/UX Design",
      "Branding",
      "On-Site SEO"
    ],
    "industry": "Frozen Snacks & Vegetable Products",
    "schema": {
      "name": "HyFun Foods Portfolio Project",
      "url": "https://abox.agency/portfolio/hyfun",
      "description": "Case study for the HyFun Foods ecommerce project covering Shopify, UI/UX Design, Branding, and On-Site SEO.",
      "image": "https://abox.agency/assets/image/portfolios/hyfun/hyfun2.webp",
      "keywords": [
        "HyFun Foods",
        "Shopify",
        "UI/UX Design",
        "Branding",
        "On-Site SEO"
      ]
    }
  },
  "/portfolio/thenga": {
    "title": "Thenga Coco Shopify Case Study | Abox Agency",
    "description": "Thenga Coco turns coconut waste into eco-friendly tableware. Abox Agency built its Shopify store from scratch, with UI/UX design and SEO for this sustainability startup.",
    "url": "https://abox.agency/portfolio/thenga",
    "image": "https://abox.agency/assets/image/portfolios/thenga/thenga2.webp",
    "keywords": "Thenga Coco, Abox Agency, coconut shell products, eco-friendly ecommerce, Shopify development, UI/UX design, portfolio case study",
    "brand": "Thenga Coco",
    "services": [
      "Shopify",
      "UI/UX Design",
      "On-Site SEO"
    ],
    "industry": "Eco-Friendly Coconut Products",
    "schema": {
      "name": "Thenga Coco Portfolio Project",
      "url": "https://abox.agency/portfolio/thenga",
      "description": "Case study for the Thenga Coco ecommerce project covering Shopify, UI/UX Design, and On-Site SEO.",
      "image": "https://abox.agency/assets/image/portfolios/thenga/thenga2.webp",
      "keywords": [
        "Thenga Coco",
        "Shopify",
        "UI/UX Design",
        "On-Site SEO"
      ]
    }
  },
  "/portfolio/sportsaber": {
    "title": "Sport Saber Shopify Case Study | Abox Agency",
    "description": "Sport Saber sells elite outdoor gear backed by a charitable mission. Abox Agency built a Shopify store with bold branding and SEO reflecting its community spirit.",
    "url": "https://abox.agency/portfolio/sportsaber",
    "image": "https://abox.agency/assets/image/portfolios/sportsaber/sportsaber2.webp",
    "keywords": "Sport Saber, Abox Agency, outdoor gear ecommerce, Shopify development, branding, on-site SEO, portfolio case study",
    "brand": "Sport Saber",
    "services": [
      "Shopify",
      "UI/UX Design",
      "Branding",
      "On-Site SEO"
    ],
    "industry": "Outdoor & Sporting Equipment",
    "schema": {
      "name": "Sport Saber Portfolio Project",
      "url": "https://abox.agency/portfolio/sportsaber",
      "description": "Case study for the Sport Saber ecommerce project covering Shopify, UI/UX Design, Branding, and On-Site SEO.",
      "image": "https://abox.agency/assets/image/portfolios/sportsaber/sportsaber2.webp",
      "keywords": [
        "Sport Saber",
        "Shopify",
        "UI/UX Design",
        "Branding",
        "On-Site SEO"
      ]
    }
  },
  "/portfolio/ubar": {
    "title": "Ubar Shopify Case Study | Abox Agency",
    "description": "Ubar makes premium health supplements and needed packaging that matched its Shopify storefront. Abox Agency delivered UI/UX design, packaging, and on-site SEO.",
    "url": "https://abox.agency/portfolio/ubar",
    "image": "https://abox.agency/assets/image/portfolios/ubar/ubar2.webp",
    "keywords": "Ubar, Abox Agency, health supplements ecommerce, Shopify development, packaging design, on-site SEO, portfolio case study",
    "brand": "Ubar",
    "services": [
      "Shopify",
      "UI/UX Design",
      "Packaging Design",
      "On-Site SEO"
    ],
    "industry": "Health Supplements",
    "schema": {
      "name": "Ubar Portfolio Project",
      "url": "https://abox.agency/portfolio/ubar",
      "description": "Case study for the Ubar ecommerce project covering Shopify, UI/UX Design, Packaging Design, and On-Site SEO.",
      "image": "https://abox.agency/assets/image/portfolios/ubar/ubar2.webp",
      "keywords": [
        "Ubar",
        "Shopify",
        "UI/UX Design",
        "Packaging Design",
        "On-Site SEO"
      ]
    }
  },
  "/portfolio/radhey-sweets": {
    "title": "Radhey Sweets Shopify Case Study | Abox Agency",
    "description": "Radhey Sweets wanted its heritage of authentic Indian sweets to shine online. Abox Agency built a Shopify store with fresh branding and SEO to grow D2C sales.",
    "url": "https://abox.agency/portfolio/radhey-sweets",
    "image": "https://abox.agency/assets/image/portfolios/radhey_sweets/radhey_sweets2.webp",
    "keywords": "Radhey Sweets, Abox Agency, Indian sweets ecommerce, Shopify development, branding, on-site SEO, portfolio case study",
    "brand": "Radhey Sweets",
    "services": [
      "Shopify",
      "UI/UX Design",
      "Branding",
      "On-Site SEO"
    ],
    "industry": "Sweets & Confectionery",
    "schema": {
      "name": "Radhey Sweets Portfolio Project",
      "url": "https://abox.agency/portfolio/radhey-sweets",
      "description": "Case study for the Radhey Sweets ecommerce project covering Shopify, UI/UX Design, Branding, and On-Site SEO.",
      "image": "https://abox.agency/assets/image/portfolios/radhey_sweets/radhey_sweets2.webp",
      "keywords": [
        "Radhey Sweets",
        "Shopify",
        "UI/UX Design",
        "Branding",
        "On-Site SEO"
      ]
    }
  },
  "/portfolio/maa-and-baby": {
    "title": "Maa & Baby Shopify Case Study | Abox Agency",
    "description": "Maa & Baby is a one-stop shop for parenting essentials. Abox Agency built a warm, easy-to-navigate Shopify store with branding and SEO tuned for new-parent shoppers.",
    "url": "https://abox.agency/portfolio/maa-and-baby",
    "image": "https://abox.agency/assets/image/portfolios/maababy/maababy1.webp",
    "keywords": "Maa & Baby, Abox Agency, baby products ecommerce, Shopify development, branding, on-site SEO, portfolio case study",
    "brand": "Maa & Baby",
    "services": [
      "Shopify",
      "UI/UX Design",
      "Branding",
      "On-Site SEO"
    ],
    "industry": "Baby & Parenting Products",
    "schema": {
      "name": "Maa & Baby Portfolio Project",
      "url": "https://abox.agency/portfolio/maa-and-baby",
      "description": "Case study for the Maa & Baby ecommerce project covering Shopify, UI/UX Design, Branding, and On-Site SEO.",
      "image": "https://abox.agency/assets/image/portfolios/maababy/maababy1.webp",
      "keywords": [
        "Maa & Baby",
        "Shopify",
        "UI/UX Design",
        "Branding",
        "On-Site SEO"
      ]
    }
  },
  "/portfolio/ekki-bekki": {
    "title": "Ekkibekki Shopify Case Study | Abox Agency",
    "description": "Ekkibekki sells designer wallpapers for artful interiors. Abox Agency built a visual-first Shopify store with custom branding and integrations to showcase every pattern.",
    "url": "https://abox.agency/portfolio/ekki-bekki",
    "image": "https://abox.agency/assets/image/portfolios/ekki_bekki/ekkibekki1.webp",
    "keywords": "Ekkibekki, Abox Agency, wallpaper ecommerce, Shopify development, branding, integrations, portfolio case study",
    "brand": "Ekkibekki",
    "services": [
      "Shopify",
      "UI/UX Design",
      "Branding",
      "Integrations"
    ],
    "industry": "Home Decor & Wallpaper",
    "schema": {
      "name": "Ekkibekki Portfolio Project",
      "url": "https://abox.agency/portfolio/ekki-bekki",
      "description": "Case study for the Ekkibekki ecommerce project covering Shopify, UI/UX Design, Branding, and Integrations.",
      "image": "https://abox.agency/assets/image/portfolios/ekki_bekki/ekkibekki1.webp",
      "keywords": [
        "Ekkibekki",
        "Shopify",
        "UI/UX Design",
        "Branding",
        "Integrations"
      ]
    }
  },
  "/portfolio/teatox-life": {
    "title": "TeaTox Life Shopify Case Study | Abox Agency",
    "description": "TeaTox Life sells herbal wellness teas across the US. Abox Agency rebuilt its Shopify store with fresh branding and 3D product renders that lifted its global presence.",
    "url": "https://abox.agency/portfolio/teatox-life",
    "image": "https://abox.agency/assets/image/og_images/teatox_life.jpg",
    "keywords": "TeaTox Life, Abox Agency, herbal tea ecommerce, Shopify development, branding, 3D rendering, portfolio case study",
    "brand": "TeaTox Life",
    "services": [
      "Shopify",
      "UI/UX Design",
      "Branding",
      "3D Rendering"
    ],
    "industry": "Herbal Tea & Wellness",
    "schema": {
      "name": "TeaTox Life Portfolio Project",
      "url": "https://abox.agency/portfolio/teatox-life",
      "description": "Case study for the TeaTox Life ecommerce project covering Shopify, UI/UX Design, Branding, and 3D Rendering.",
      "image": "https://abox.agency/assets/image/og_images/teatox_life.jpg",
      "keywords": [
        "TeaTox Life",
        "Shopify",
        "UI/UX Design",
        "Branding",
        "3D Rendering"
      ]
    }
  },
  "/portfolio/naturare": {
    "title": "Naturare Shopify Case Study | Abox Agency",
    "description": "Naturare champions natural, empowering wellness products. Abox Agency built its Shopify store with custom branding and 3D renders that bring each product to life online.",
    "url": "https://abox.agency/portfolio/naturare",
    "image": "https://abox.agency/assets/image/portfolios/naturare/naturare1.webp",
    "keywords": "Naturare, Abox Agency, natural wellness ecommerce, Shopify development, branding, 3D rendering, portfolio case study",
    "brand": "Naturare",
    "services": [
      "Shopify",
      "UI/UX Design",
      "Branding",
      "3D Rendering"
    ],
    "industry": "Natural Wellness Products",
    "schema": {
      "name": "Naturare Portfolio Project",
      "url": "https://abox.agency/portfolio/naturare",
      "description": "Case study for the Naturare ecommerce project covering Shopify, UI/UX Design, Branding, and 3D Rendering.",
      "image": "https://abox.agency/assets/image/portfolios/naturare/naturare1.webp",
      "keywords": [
        "Naturare",
        "Shopify",
        "UI/UX Design",
        "Branding",
        "3D Rendering"
      ]
    }
  },
  "/portfolio/neo-roots": {
    "title": "Neo Roots Shopify Case Study | Abox Agency",
    "description": "Neo Roots designs custom greenery for indoor and outdoor spaces. Abox Agency built a Shopify store with nature-inspired branding and integrations for easy ordering.",
    "url": "https://abox.agency/portfolio/neo-roots",
    "image": "https://abox.agency/assets/image/portfolios/neoroots/neoroots1.webp",
    "keywords": "Neo Roots, Abox Agency, plant ecommerce, Shopify development, branding, integrations, portfolio case study",
    "brand": "Neo Roots",
    "services": [
      "Shopify",
      "UI/UX Design",
      "Branding",
      "Integrations"
    ],
    "industry": "Plants & Greenery",
    "schema": {
      "name": "Neo Roots Portfolio Project",
      "url": "https://abox.agency/portfolio/neo-roots",
      "description": "Case study for the Neo Roots ecommerce project covering Shopify, UI/UX Design, Branding, and Integrations.",
      "image": "https://abox.agency/assets/image/portfolios/neoroots/neoroots1.webp",
      "keywords": [
        "Neo Roots",
        "Shopify",
        "UI/UX Design",
        "Branding",
        "Integrations"
      ]
    }
  },
  "/portfolio/uppercase": {
    "title": "Uppercase Shopify Case Study | Abox Agency",
    "description": "Uppercase makes eco-friendly, stylish travel bags. Abox Agency migrated the brand to Shopify with fresh UI/UX design and SEO to support its sustainability story.",
    "url": "https://abox.agency/portfolio/uppercase",
    "image": "https://abox.agency/assets/image/portfolios/uppercase/uppercase1.webp",
    "keywords": "Uppercase, Abox Agency, eco-friendly bags, Shopify migration, UI/UX design, SEO, portfolio case study",
    "brand": "Uppercase",
    "services": [
      "Shopify",
      "UI/UX Design",
      "Branding",
      "SEO"
    ],
    "industry": "Eco-Friendly Travel Gear",
    "schema": {
      "name": "Uppercase Portfolio Project",
      "url": "https://abox.agency/portfolio/uppercase",
      "description": "Case study for the Uppercase ecommerce project covering Shopify, UI/UX Design, Branding, and SEO.",
      "image": "https://abox.agency/assets/image/portfolios/uppercase/uppercase1.webp",
      "keywords": [
        "Uppercase",
        "Shopify",
        "UI/UX Design",
        "Branding",
        "SEO"
      ]
    }
  },
  "/portfolio/healing-hands": {
    "title": "Healing Hands Shopify Case Study | Abox Agency",
    "description": "Healing Hands makes plant-based medicine for piles and constipation relief. Abox Agency built a discreet, trustworthy Shopify store with branding and on-site SEO.",
    "url": "https://abox.agency/portfolio/healing-hands",
    "image": "https://abox.agency/assets/image/og_images/healing_hands.jpg",
    "keywords": "Healing Hands, Abox Agency, plant-based medicine, Shopify development, branding, on-site SEO, portfolio case study",
    "brand": "Healing Hands",
    "services": [
      "Shopify",
      "UI/UX Design",
      "Branding",
      "On-Site SEO"
    ],
    "industry": "Piles & Digestive Care",
    "schema": {
      "name": "Healing Hands Portfolio Project",
      "url": "https://abox.agency/portfolio/healing-hands",
      "description": "Case study for the Healing Hands ecommerce project covering Shopify, UI/UX Design, Branding, and On-Site SEO.",
      "image": "https://abox.agency/assets/image/og_images/healing_hands.jpg",
      "keywords": [
        "Healing Hands",
        "Shopify",
        "UI/UX Design",
        "Branding",
        "On-Site SEO"
      ]
    }
  },
  "/portfolio/kutum-ayurveda": {
    "title": "Kutum Ayurveda Shopify Case Study | Abox Agency",
    "description": "Kutum Ayurveda blends ancient Ayurvedic care with modern skincare. Abox Agency built its Shopify store with custom branding and 3D product design for a premium feel.",
    "url": "https://abox.agency/portfolio/kutum-ayurveda",
    "image": "https://abox.agency/assets/image/portfolios/kutum/kutum1.webp",
    "keywords": "Kutum Ayurveda, Abox Agency, Ayurvedic skincare ecommerce, Shopify development, branding, 3D design, portfolio case study",
    "brand": "Kutum Ayurveda",
    "services": [
      "Shopify",
      "UI/UX Design",
      "Branding",
      "3D Design"
    ],
    "industry": "Ayurvedic Skincare & Cosmetics",
    "schema": {
      "name": "Kutum Ayurveda Portfolio Project",
      "url": "https://abox.agency/portfolio/kutum-ayurveda",
      "description": "Case study for the Kutum Ayurveda ecommerce project covering Shopify, UI/UX Design, Branding, and 3D Design.",
      "image": "https://abox.agency/assets/image/portfolios/kutum/kutum1.webp",
      "keywords": [
        "Kutum Ayurveda",
        "Shopify",
        "UI/UX Design",
        "Branding",
        "3D Design"
      ]
    }
  },
  "/portfolio/nurdle": {
    "title": "Nurdle Shopify Case Study | Abox Agency",
    "description": "Nurdle sells colorful kids' underwear with surprise gifts inside. Abox Agency built a playful Shopify store with branding and graphics that appeal to parents and kids.",
    "url": "https://abox.agency/portfolio/nurdle",
    "image": "https://abox.agency/assets/image/portfolios/nurdle/nurdle1.webp",
    "keywords": "Nurdle, Abox Agency, kids apparel ecommerce, Shopify development, branding, graphic design, portfolio case study",
    "brand": "Nurdle",
    "services": [
      "Shopify",
      "UI/UX Design",
      "Branding",
      "Graphic Design"
    ],
    "industry": "Kids' Apparel",
    "schema": {
      "name": "Nurdle Portfolio Project",
      "url": "https://abox.agency/portfolio/nurdle",
      "description": "Case study for the Nurdle ecommerce project covering Shopify, UI/UX Design, Branding, and Graphic Design.",
      "image": "https://abox.agency/assets/image/portfolios/nurdle/nurdle1.webp",
      "keywords": [
        "Nurdle",
        "Shopify",
        "UI/UX Design",
        "Branding",
        "Graphic Design"
      ]
    }
  },
  "/portfolio/technosport": {
    "title": "Techno Sport Shopify Case Study | Abox Agency",
    "description": "Techno Sport needed a seamless move from CartMax to Shopify without losing a single order. Abox Agency handled the migration, custom integrations, and on-site SEO.",
    "url": "https://abox.agency/portfolio/technosport",
    "image": "https://abox.agency/assets/image/portfolios/technosport/technosport1.webp",
    "keywords": "Techno Sport, Abox Agency, athleisure ecommerce, Shopify migration, web development, on-site SEO, portfolio case study",
    "brand": "Techno Sport",
    "services": [
      "Shopify",
      "Web Development",
      "On-Site SEO"
    ],
    "industry": "Athleisure & Sportswear",
    "schema": {
      "name": "Techno Sport Portfolio Project",
      "url": "https://abox.agency/portfolio/technosport",
      "description": "Case study for the Techno Sport ecommerce project covering Shopify, Web Development, and On-Site SEO.",
      "image": "https://abox.agency/assets/image/portfolios/technosport/technosport1.webp",
      "keywords": [
        "Techno Sport",
        "Shopify",
        "Web Development",
        "On-Site SEO"
      ]
    }
  },
  "/portfolio/myoa-cookies": {
    "title": "Myoa Cookies Shopify Case Study | Abox Agency",
    "description": "Myoa Cookies bakes luxury cookies with premium ingredients. Abox Agency designed a custom Figma-to-Shopify store with fresh branding to match its indulgent positioning.",
    "url": "https://abox.agency/portfolio/myoa-cookies",
    "image": "https://abox.agency/assets/image/portfolios/myoa_cookies/cookies1.webp",
    "keywords": "Myoa Cookies, Abox Agency, gourmet cookies ecommerce, Shopify development, branding, graphic design, portfolio case study",
    "brand": "Myoa Cookies",
    "services": [
      "Shopify",
      "UI/UX Design",
      "Branding",
      "Graphic Design"
    ],
    "industry": "Gourmet Cookies & Snacks",
    "schema": {
      "name": "Myoa Cookies Portfolio Project",
      "url": "https://abox.agency/portfolio/myoa-cookies",
      "description": "Case study for the Myoa Cookies ecommerce project covering Shopify, UI/UX Design, Branding, and Graphic Design.",
      "image": "https://abox.agency/assets/image/portfolios/myoa_cookies/cookies1.webp",
      "keywords": [
        "Myoa Cookies",
        "Shopify",
        "UI/UX Design",
        "Branding",
        "Graphic Design"
      ]
    }
  },
  "/portfolio/bontrue-furniture": {
    "title": "Bontrue Furniture Shopify Case Study | Abox Agency",
    "description": "Bontrue Furniture sells stylish, functional pieces for modern homes. Abox Agency built a Shopify store with a gift registry, custom UI/UX, and on-site SEO.",
    "url": "https://abox.agency/portfolio/bontrue-furniture",
    "image": "https://abox.agency/assets/image/portfolios/bontrue_furniture/furniture1.webp",
    "keywords": "Bontrue Furniture, Abox Agency, furniture ecommerce, Shopify development, UI/UX design, on-site SEO, portfolio case study",
    "brand": "Bontrue Furniture",
    "services": [
      "Shopify",
      "UI/UX Design",
      "Branding",
      "On-Site SEO"
    ],
    "industry": "Furniture & Home Decor",
    "schema": {
      "name": "Bontrue Furniture Portfolio Project",
      "url": "https://abox.agency/portfolio/bontrue-furniture",
      "description": "Case study for the Bontrue Furniture ecommerce project covering Shopify, UI/UX Design, Branding, and On-Site SEO.",
      "image": "https://abox.agency/assets/image/portfolios/bontrue_furniture/furniture1.webp",
      "keywords": [
        "Bontrue Furniture",
        "Shopify",
        "UI/UX Design",
        "Branding",
        "On-Site SEO"
      ]
    }
  },
  "/portfolio/nourysh": {
    "title": "Nourysh Shopify Case Study | Abox Agency",
    "description": "Nourysh makes science-backed nutritional formulations for everyday health. Abox Agency delivered a Shopify store with branding and on-site SEO for self-care shoppers.",
    "url": "https://abox.agency/portfolio/nourysh",
    "image": "https://abox.agency/assets/image/og_images/nourysh.jpg",
    "keywords": "Nourysh, Abox Agency, nutrition supplements ecommerce, Shopify development, branding, on-site SEO, portfolio case study",
    "brand": "Nourysh",
    "services": [
      "Shopify",
      "UI/UX Design",
      "Branding",
      "On-Site SEO"
    ],
    "industry": "Nutritional Health Supplements",
    "schema": {
      "name": "Nourysh Portfolio Project",
      "url": "https://abox.agency/portfolio/nourysh",
      "description": "Case study for the Nourysh ecommerce project covering Shopify, UI/UX Design, Branding, and On-Site SEO.",
      "image": "https://abox.agency/assets/image/og_images/nourysh.jpg",
      "keywords": [
        "Nourysh",
        "Shopify",
        "UI/UX Design",
        "Branding",
        "On-Site SEO"
      ]
    }
  },
  "/portfolio/bayla": {
    "title": "Bayla Skins Shopify Case Study | Abox Agency",
    "description": "Bayla Skins offers natural, science-backed skincare. Abox Agency built its Shopify store with clean UI/UX and branding that puts ingredient transparency front and centre.",
    "url": "https://abox.agency/portfolio/bayla",
    "image": "https://abox.agency/assets/image/og_images/bayla_skins.jpg",
    "keywords": "Bayla Skins, Abox Agency, skincare ecommerce, Shopify development, branding, on-site SEO, portfolio case study",
    "brand": "Bayla Skins",
    "services": [
      "Shopify",
      "UI/UX Design",
      "Branding",
      "On-Site SEO"
    ],
    "industry": "Skincare Products",
    "schema": {
      "name": "Bayla Skins Portfolio Project",
      "url": "https://abox.agency/portfolio/bayla",
      "description": "Case study for the Bayla Skins ecommerce project covering Shopify, UI/UX Design, Branding, and On-Site SEO.",
      "image": "https://abox.agency/assets/image/og_images/bayla_skins.jpg",
      "keywords": [
        "Bayla Skins",
        "Shopify",
        "UI/UX Design",
        "Branding",
        "On-Site SEO"
      ]
    }
  },
  "/portfolio/prakruti": {
    "title": "Prakruti Pure Herbs Shopify Case Study | Abox Agency",
    "description": "Prakruti Pure Herbs sells Ayurvedic medicine, supplements, and skin and hair care. Abox Agency built its Shopify store with branding and 3D renders across the range.",
    "url": "https://abox.agency/portfolio/prakruti",
    "image": "https://abox.agency/assets/image/portfolios/prakruti/prakruti2.webp",
    "keywords": "Prakruti Pure Herbs, Abox Agency, Ayurvedic ecommerce, Shopify development, branding, 3D rendering, portfolio case study",
    "brand": "Prakruti Pure Herbs",
    "services": [
      "Shopify",
      "UI/UX Design",
      "Branding",
      "3D Rendering"
    ],
    "industry": "Ayurvedic Medicine & Supplements",
    "schema": {
      "name": "Prakruti Pure Herbs Portfolio Project",
      "url": "https://abox.agency/portfolio/prakruti",
      "description": "Case study for the Prakruti Pure Herbs ecommerce project covering Shopify, UI/UX Design, Branding, and 3D Rendering.",
      "image": "https://abox.agency/assets/image/portfolios/prakruti/prakruti2.webp",
      "keywords": [
        "Prakruti Pure Herbs",
        "Shopify",
        "UI/UX Design",
        "Branding",
        "3D Rendering"
      ]
    }
  },
  "/portfolio/hamdard": {
    "title": "Hamdard Shopify Case Study | Abox Agency",
    "description": "Hamdard, India's leading Unani medicine brand, wanted a direct-to-consumer channel for its sharbats and spices. Abox Agency built the Shopify store with branding and SEO.",
    "url": "https://abox.agency/portfolio/hamdard",
    "image": "https://abox.agency/assets/image/portfolios/hamdard/hamdard2.webp",
    "keywords": "Hamdard, Abox Agency, Unani medicine ecommerce, Shopify development, branding, on-site SEO, portfolio case study",
    "brand": "Hamdard",
    "services": [
      "Shopify",
      "UI/UX Design",
      "Branding",
      "On-Site SEO"
    ],
    "industry": "Unani Medicine & Beverages",
    "schema": {
      "name": "Hamdard Portfolio Project",
      "url": "https://abox.agency/portfolio/hamdard",
      "description": "Case study for the Hamdard ecommerce project covering Shopify, UI/UX Design, Branding, and On-Site SEO.",
      "image": "https://abox.agency/assets/image/portfolios/hamdard/hamdard2.webp",
      "keywords": [
        "Hamdard",
        "Shopify",
        "UI/UX Design",
        "Branding",
        "On-Site SEO"
      ]
    }
  },
  "/portfolio/shistaka": {
    "title": "Shistaka Shopify Case Study | Abox Agency",
    "description": "Shistaka blends Ayurvedic wisdom with modern wellness in its herbal teas. Abox Agency built a Shopify store with custom branding and 3D renders for every product.",
    "url": "https://abox.agency/portfolio/shistaka",
    "image": "https://abox.agency/assets/image/portfolios/shistaka/shistaka2.webp",
    "keywords": "Shistaka, Abox Agency, herbal tea ecommerce, Shopify development, branding, 3D rendering, portfolio case study",
    "brand": "Shistaka",
    "services": [
      "Shopify",
      "UI/UX Design",
      "Branding",
      "3D Rendering"
    ],
    "industry": "Herbal Tea & Wellness",
    "schema": {
      "name": "Shistaka Portfolio Project",
      "url": "https://abox.agency/portfolio/shistaka",
      "description": "Case study for the Shistaka ecommerce project covering Shopify, UI/UX Design, Branding, and 3D Rendering.",
      "image": "https://abox.agency/assets/image/portfolios/shistaka/shistaka2.webp",
      "keywords": [
        "Shistaka",
        "Shopify",
        "UI/UX Design",
        "Branding",
        "3D Rendering"
      ]
    }
  },
  "/portfolio/freshleaf": {
    "title": "FreshLeaf Shopify Case Study | Abox Agency",
    "description": "FreshLeaf sells pure, handpicked teas for tea enthusiasts. Abox Agency built its Shopify store with fresh branding and graphics that highlight product freshness.",
    "url": "https://abox.agency/portfolio/freshleaf",
    "image": "https://abox.agency/assets/image/portfolios/freshleaf/freshleaf2.webp",
    "keywords": "FreshLeaf, Abox Agency, specialty tea ecommerce, Shopify development, branding, graphic design, portfolio case study",
    "brand": "FreshLeaf",
    "services": [
      "Shopify",
      "UI/UX Design",
      "Branding",
      "Graphic Design"
    ],
    "industry": "Specialty Tea",
    "schema": {
      "name": "FreshLeaf Portfolio Project",
      "url": "https://abox.agency/portfolio/freshleaf",
      "description": "Case study for the FreshLeaf ecommerce project covering Shopify, UI/UX Design, Branding, and Graphic Design.",
      "image": "https://abox.agency/assets/image/portfolios/freshleaf/freshleaf2.webp",
      "keywords": [
        "FreshLeaf",
        "Shopify",
        "UI/UX Design",
        "Branding",
        "Graphic Design"
      ]
    }
  },
  "/portfolio/healthoxide": {
    "title": "Healthoxide Shopify Case Study | Abox Agency",
    "description": "Healthoxide sells sports supplements and diet nutrition products. Abox Agency built its Shopify store with performance-focused branding and graphic design.",
    "url": "https://abox.agency/portfolio/healthoxide",
    "image": "https://abox.agency/assets/image/portfolios/healthoxide/healthoxide2.webp",
    "keywords": "Healthoxide, Abox Agency, sports nutrition ecommerce, Shopify development, branding, graphic design, portfolio case study",
    "brand": "Healthoxide",
    "services": [
      "Shopify",
      "UI/UX Design",
      "Branding",
      "Graphic Design"
    ],
    "industry": "Sports Nutrition & Fitness Supplements",
    "schema": {
      "name": "Healthoxide Portfolio Project",
      "url": "https://abox.agency/portfolio/healthoxide",
      "description": "Case study for the Healthoxide ecommerce project covering Shopify, UI/UX Design, Branding, and Graphic Design.",
      "image": "https://abox.agency/assets/image/portfolios/healthoxide/healthoxide2.webp",
      "keywords": [
        "Healthoxide",
        "Shopify",
        "UI/UX Design",
        "Branding",
        "Graphic Design"
      ]
    }
  },
  "/portfolio/gogrub": {
    "title": "Go Grub Shopify Case Study | Abox Agency",
    "description": "Go Grub sells wholesome snacks, cookies, and pantry picks. Abox Agency built a flavour-forward Shopify store with custom branding and graphic design.",
    "url": "https://abox.agency/portfolio/gogrub",
    "image": "https://abox.agency/assets/image/portfolios/go_grub/gogrub1.webp",
    "keywords": "Go Grub, Abox Agency, snacks ecommerce, Shopify development, branding, graphic design, portfolio case study",
    "brand": "Go Grub",
    "services": [
      "Shopify",
      "UI/UX Design",
      "Branding",
      "Graphic Design"
    ],
    "industry": "Snacks & Pantry Foods",
    "schema": {
      "name": "Go Grub Portfolio Project",
      "url": "https://abox.agency/portfolio/gogrub",
      "description": "Case study for the Go Grub ecommerce project covering Shopify, UI/UX Design, Branding, and Graphic Design.",
      "image": "https://abox.agency/assets/image/portfolios/go_grub/gogrub1.webp",
      "keywords": [
        "Go Grub",
        "Shopify",
        "UI/UX Design",
        "Branding",
        "Graphic Design"
      ]
    }
  },
  "/portfolio/mypro": {
    "title": "My Pro Sport Nutritions Case Study | Abox Agency",
    "description": "My Pro Sport Nutritions sells protein and performance supplements worldwide. Abox Agency delivered a Shopify store with label design, branding, and 3D product renders.",
    "url": "https://abox.agency/portfolio/mypro",
    "image": "https://abox.agency/assets/image/portfolios/mypro/mypro1.webp",
    "keywords": "My Pro Sport Nutritions, Abox Agency, sports supplements ecommerce, Shopify development, branding, 3D rendering, portfolio case study",
    "brand": "My Pro Sport Nutritions",
    "services": [
      "Shopify",
      "UI/UX Design",
      "Branding",
      "3D Rendering"
    ],
    "industry": "Sports Nutrition & Supplements",
    "schema": {
      "name": "My Pro Sport Nutritions Portfolio Project",
      "url": "https://abox.agency/portfolio/mypro",
      "description": "Case study for the My Pro Sport Nutritions ecommerce project covering Shopify, UI/UX Design, Branding, and 3D Rendering.",
      "image": "https://abox.agency/assets/image/portfolios/mypro/mypro1.webp",
      "keywords": [
        "My Pro Sport Nutritions",
        "Shopify",
        "UI/UX Design",
        "Branding",
        "3D Rendering"
      ]
    }
  },
  "/portfolio/aumex": {
    "title": "Aumex Shopify Case Study | Abox Agency",
    "description": "Aumex makes women's intimate hygiene products, including its V Wonder Wash line. Abox Agency built a Shopify store with careful branding and 3D product renders.",
    "url": "https://abox.agency/portfolio/aumex",
    "image": "https://abox.agency/assets/image/portfolios/aumex/aumex1.webp",
    "keywords": "Aumex, Abox Agency, intimate hygiene ecommerce, Shopify development, branding, 3D rendering, portfolio case study",
    "brand": "Aumex",
    "services": [
      "Shopify",
      "UI/UX Design",
      "Branding",
      "3D Rendering"
    ],
    "industry": "Intimate Hygiene & Personal Care",
    "schema": {
      "name": "Aumex Portfolio Project",
      "url": "https://abox.agency/portfolio/aumex",
      "description": "Case study for the Aumex ecommerce project covering Shopify, UI/UX Design, Branding, and 3D Rendering.",
      "image": "https://abox.agency/assets/image/portfolios/aumex/aumex1.webp",
      "keywords": [
        "Aumex",
        "Shopify",
        "UI/UX Design",
        "Branding",
        "3D Rendering"
      ]
    }
  },
  "/portfolio/within-beauty": {
    "title": "Within Beauty Shopify Case Study | Abox Agency",
    "description": "Within Beauty makes cruelty-free skincare with natural ingredients. Abox Agency built a Shopify store with clean UI/UX and 3D renders to spotlight its formulas.",
    "url": "https://abox.agency/portfolio/within-beauty",
    "image": "https://abox.agency/assets/image/portfolios/within/within1.webp",
    "keywords": "Within Beauty, Abox Agency, cosmetics ecommerce, Shopify development, UI/UX design, 3D rendering, portfolio case study",
    "brand": "Within Beauty",
    "services": [
      "Shopify",
      "UI/UX Design",
      "Branding",
      "3D Rendering"
    ],
    "industry": "Cosmetics & Skincare",
    "schema": {
      "name": "Within Beauty Portfolio Project",
      "url": "https://abox.agency/portfolio/within-beauty",
      "description": "Case study for the Within Beauty ecommerce project covering Shopify, UI/UX Design, Branding, and 3D Rendering.",
      "image": "https://abox.agency/assets/image/portfolios/within/within1.webp",
      "keywords": [
        "Within Beauty",
        "Shopify",
        "UI/UX Design",
        "Branding",
        "3D Rendering"
      ]
    }
  },
  "/portfolio/om-sweets": {
    "title": "Om Sweets & Snacks Shopify Case Study | Abox Agency",
    "description": "Om Sweets & Snacks offers authentic sweets for every Indian festival and occasion. Abox Agency built a Shopify store with warm branding and graphic design.",
    "url": "https://abox.agency/portfolio/om-sweets",
    "image": "https://abox.agency/assets/image/portfolios/om_sweets/omsweets1.webp",
    "keywords": "Om Sweets, Abox Agency, Indian sweets ecommerce, Shopify development, branding, graphic design, portfolio case study",
    "brand": "Om Sweets & Snacks",
    "services": [
      "Shopify",
      "UI/UX Design",
      "Branding",
      "Graphic Design"
    ],
    "industry": "Indian Sweets & Snacks",
    "schema": {
      "name": "Om Sweets & Snacks Portfolio Project",
      "url": "https://abox.agency/portfolio/om-sweets",
      "description": "Case study for the Om Sweets & Snacks ecommerce project covering Shopify, UI/UX Design, Branding, and Graphic Design.",
      "image": "https://abox.agency/assets/image/portfolios/om_sweets/omsweets1.webp",
      "keywords": [
        "Om Sweets & Snacks",
        "Shopify",
        "UI/UX Design",
        "Branding",
        "Graphic Design"
      ]
    }
  },
  "/portfolio/yo-gathiya": {
    "title": "Yo Gathiya Shopify Case Study | Abox Agency",
    "description": "Yo Gathiya brings premium Gujarati namkeen online. Abox Agency built its Shopify store with custom branding and label design that carries the brand's tradition forward.",
    "url": "https://abox.agency/portfolio/yo-gathiya",
    "image": "https://abox.agency/assets/image/portfolios/yogathiya/yogathiya1.webp",
    "keywords": "Yo Gathiya, Abox Agency, namkeen ecommerce, Shopify development, branding, label design, portfolio case study",
    "brand": "Yo Gathiya",
    "services": [
      "Shopify",
      "UI/UX Design",
      "Branding",
      "Label Design"
    ],
    "industry": "Namkeen & Savory Snacks",
    "schema": {
      "name": "Yo Gathiya Portfolio Project",
      "url": "https://abox.agency/portfolio/yo-gathiya",
      "description": "Case study for the Yo Gathiya ecommerce project covering Shopify, UI/UX Design, Branding, and Label Design.",
      "image": "https://abox.agency/assets/image/portfolios/yogathiya/yogathiya1.webp",
      "keywords": [
        "Yo Gathiya",
        "Shopify",
        "UI/UX Design",
        "Branding",
        "Label Design"
      ]
    }
  },
  "/portfolio/arospice": {
    "title": "Arospice Shopify Case Study | Abox Agency",
    "description": "Arospice sells premium Indian spices and millets rooted in tradition. Abox Agency built a Shopify store with rich branding and graphic design for the D2C launch.",
    "url": "https://abox.agency/portfolio/arospice",
    "image": "https://abox.agency/assets/image/portfolios/arospice/arospice1.webp",
    "keywords": "Arospice, Abox Agency, Indian spices ecommerce, Shopify development, branding, graphic design, portfolio case study",
    "brand": "Arospice",
    "services": [
      "Shopify",
      "UI/UX Design",
      "Branding",
      "Graphic Design"
    ],
    "industry": "Indian Spices & Millets",
    "schema": {
      "name": "Arospice Portfolio Project",
      "url": "https://abox.agency/portfolio/arospice",
      "description": "Case study for the Arospice ecommerce project covering Shopify, UI/UX Design, Branding, and Graphic Design.",
      "image": "https://abox.agency/assets/image/portfolios/arospice/arospice1.webp",
      "keywords": [
        "Arospice",
        "Shopify",
        "UI/UX Design",
        "Branding",
        "Graphic Design"
      ]
    }
  },
  "/portfolio/repeat-gud": {
    "title": "Repeat Gud Shopify Case Study | Abox Agency",
    "description": "Repeat Gud makes all-natural, nutrient-packed sauces. Abox Agency built its Shopify site with custom development, on-site SEO, and integrations for ethical sourcing.",
    "url": "https://abox.agency/portfolio/repeat-gud",
    "image": "https://abox.agency/assets/image/portfolios/repeat_gud/repeat1.webp",
    "keywords": "Repeat Gud, Abox Agency, natural sauces ecommerce, Shopify development, on-site SEO, integrations, portfolio case study",
    "brand": "Repeat Gud",
    "services": [
      "Shopify",
      "Web Development",
      "On-Site SEO",
      "Integrations"
    ],
    "industry": "Natural Sauces & Condiments",
    "schema": {
      "name": "Repeat Gud Portfolio Project",
      "url": "https://abox.agency/portfolio/repeat-gud",
      "description": "Case study for the Repeat Gud ecommerce project covering Shopify, Web Development, On-Site SEO, and Integrations.",
      "image": "https://abox.agency/assets/image/portfolios/repeat_gud/repeat1.webp",
      "keywords": [
        "Repeat Gud",
        "Shopify",
        "Web Development",
        "On-Site SEO",
        "Integrations"
      ]
    }
  },
  "/portfolio/spark-fusion": {
    "title": "Spark Fusion Shopify Case Study | Abox Agency",
    "description": "Spark Fusion sells premium fitness supplements for strength and health. Abox Agency built a Shopify store with 3D renders and infographics to boost conversion.",
    "url": "https://abox.agency/portfolio/spark-fusion",
    "image": "https://abox.agency/assets/image/portfolios/sparkfusion/sparkfusion1.webp",
    "keywords": "Spark Fusion, Abox Agency, fitness supplements ecommerce, Shopify development, 3D rendering, portfolio case study",
    "brand": "Spark Fusion",
    "services": [
      "Shopify",
      "UI/UX Design",
      "Branding",
      "3D Rendering"
    ],
    "industry": "Fitness & Nutrition Supplements",
    "schema": {
      "name": "Spark Fusion Portfolio Project",
      "url": "https://abox.agency/portfolio/spark-fusion",
      "description": "Case study for the Spark Fusion ecommerce project covering Shopify, UI/UX Design, Branding, and 3D Rendering.",
      "image": "https://abox.agency/assets/image/portfolios/sparkfusion/sparkfusion1.webp",
      "keywords": [
        "Spark Fusion",
        "Shopify",
        "UI/UX Design",
        "Branding",
        "3D Rendering"
      ]
    }
  },
  "/portfolio/bhagavad-gita": {
    "title": "Bhagavad Gita Shopify Case Study | Abox Agency",
    "description": "This Krsna Consciousness store sells Vedic scriptures and spiritual teachings. Abox Agency built a Shopify store with UI/UX and product design for sacred commerce.",
    "url": "https://abox.agency/portfolio/bhagavad-gita",
    "image": "https://abox.agency/assets/image/og_images/bhagavad_gita.jpg",
    "keywords": "Bhagavad Gita, Abox Agency, spiritual books ecommerce, Shopify development, UI/UX design, product design, portfolio case study",
    "brand": "Bhagavad Gita",
    "services": [
      "Shopify",
      "UI/UX Design",
      "Branding",
      "Product Design"
    ],
    "industry": "Spiritual Books & Scriptures",
    "schema": {
      "name": "Bhagavad Gita Portfolio Project",
      "url": "https://abox.agency/portfolio/bhagavad-gita",
      "description": "Case study for the Bhagavad Gita ecommerce project covering Shopify, UI/UX Design, Branding, and Product Design.",
      "image": "https://abox.agency/assets/image/og_images/bhagavad_gita.jpg",
      "keywords": [
        "Bhagavad Gita",
        "Shopify",
        "UI/UX Design",
        "Branding",
        "Product Design"
      ]
    }
  },
  "/portfolio/weight-manage": {
    "title": "Weight Manage Shopify Case Study | Abox Agency",
    "description": "Weight Manage sells supplements for effective, healthy weight management. Abox Agency built a Shopify store with custom branding and 3D renders for its product line.",
    "url": "https://abox.agency/portfolio/weight-manage",
    "image": "https://abox.agency/assets/image/og_images/weight_manage.jpg",
    "keywords": "Weight Manage, Abox Agency, weight management ecommerce, Shopify development, branding, 3D rendering, portfolio case study",
    "brand": "Weight Manage",
    "services": [
      "Shopify",
      "UI/UX Design",
      "Branding",
      "3D Rendering"
    ],
    "industry": "Weight Management & Healthcare",
    "schema": {
      "name": "Weight Manage Portfolio Project",
      "url": "https://abox.agency/portfolio/weight-manage",
      "description": "Case study for the Weight Manage ecommerce project covering Shopify, UI/UX Design, Branding, and 3D Rendering.",
      "image": "https://abox.agency/assets/image/og_images/weight_manage.jpg",
      "keywords": [
        "Weight Manage",
        "Shopify",
        "UI/UX Design",
        "Branding",
        "3D Rendering"
      ]
    }
  },
  "/portfolio/agarwalbhavan-sweets": {
    "title": "Agarwal Bhavan Sweets Case Study | Abox Agency",
    "description": "Agarwal Bhavan Sweets wanted its traditional Indian sweets business online. Abox Agency built a Shopify store with custom branding to boost visibility and engagement.",
    "url": "https://abox.agency/portfolio/agarwalbhavan-sweets",
    "image": "https://abox.agency/assets/image/portfolios/agarwal_sweets/agarwalsweets1.webp",
    "keywords": "Agarwal Bhavan Sweets, Abox Agency, confectionery ecommerce, Shopify development, branding, graphic design, portfolio case study",
    "brand": "Agarwal Bhavan Sweets",
    "services": [
      "Shopify",
      "UI/UX Design",
      "Branding",
      "Graphic Design"
    ],
    "industry": "Confectionery & Sweets",
    "schema": {
      "name": "Agarwal Bhavan Sweets Portfolio Project",
      "url": "https://abox.agency/portfolio/agarwalbhavan-sweets",
      "description": "Case study for the Agarwal Bhavan Sweets ecommerce project covering Shopify, UI/UX Design, Branding, and Graphic Design.",
      "image": "https://abox.agency/assets/image/portfolios/agarwal_sweets/agarwalsweets1.webp",
      "keywords": [
        "Agarwal Bhavan Sweets",
        "Shopify",
        "UI/UX Design",
        "Branding",
        "Graphic Design"
      ]
    }
  },
  "/portfolio/murari-sweets": {
    "title": "Murari Sweets Shopify Case Study | Abox Agency",
    "description": "Murari Sweets offers a diverse range of authentic Indian sweets. Abox Agency redefined its online presence with custom UI/UX design and Shopify development.",
    "url": "https://abox.agency/portfolio/murari-sweets",
    "image": "https://abox.agency/assets/image/portfolios/murari_sweet/murarisweet1.webp",
    "keywords": "Murari Sweets, Abox Agency, confectionery ecommerce, Shopify development, UI/UX design, portfolio case study",
    "brand": "Murari Sweets",
    "services": [
      "Shopify",
      "UI/UX Design",
      "Web Development"
    ],
    "industry": "Confectionery & Sweets",
    "schema": {
      "name": "Murari Sweets Portfolio Project",
      "url": "https://abox.agency/portfolio/murari-sweets",
      "description": "Case study for the Murari Sweets ecommerce project covering Shopify, UI/UX Design, and Web Development.",
      "image": "https://abox.agency/assets/image/portfolios/murari_sweet/murarisweet1.webp",
      "keywords": [
        "Murari Sweets",
        "Shopify",
        "UI/UX Design",
        "Web Development"
      ]
    }
  },
  "/portfolio/singlas-sweets": {
    "title": "Singla Sweets Shopify Case Study | Abox Agency",
    "description": "Singla Sweets makes authentic, handmade Indian delicacies. Abox Agency built a Shopify store with UI/UX design and web development as polished as the sweets themselves.",
    "url": "https://abox.agency/portfolio/singlas-sweets",
    "image": "https://abox.agency/assets/image/portfolios/singlas/singlas1.webp",
    "keywords": "Singla Sweets, Abox Agency, confectionery ecommerce, Shopify development, UI/UX design, portfolio case study",
    "brand": "Singla Sweets",
    "services": [
      "Shopify",
      "UI/UX Design",
      "Web Development"
    ],
    "industry": "Confectionery & Sweets",
    "schema": {
      "name": "Singla Sweets Portfolio Project",
      "url": "https://abox.agency/portfolio/singlas-sweets",
      "description": "Case study for the Singla Sweets ecommerce project covering Shopify, UI/UX Design, and Web Development.",
      "image": "https://abox.agency/assets/image/portfolios/singlas/singlas1.webp",
      "keywords": [
        "Singla Sweets",
        "Shopify",
        "UI/UX Design",
        "Web Development"
      ]
    }
  },
  "/portfolio/savani-jewellery": {
    "title": "Savani Jewellery Shopify Case Study | Abox Agency",
    "description": "Savani Jewellery makes elegant, sustainable diamond jewellery. Abox Agency redesigned its Shopify site with SEO and integrations to simplify international shopping.",
    "url": "https://abox.agency/portfolio/savani-jewellery",
    "image": "https://abox.agency/assets/image/portfolios/savani/savani1.webp",
    "keywords": "Savani Jewellery, Abox Agency, fine jewellery ecommerce, Shopify development, SEO, integrations, portfolio case study",
    "brand": "Savani Jewellery",
    "services": [
      "Shopify",
      "Web Development",
      "SEO",
      "Integrations"
    ],
    "industry": "Fine Jewellery Manufacturing",
    "schema": {
      "name": "Savani Jewellery Portfolio Project",
      "url": "https://abox.agency/portfolio/savani-jewellery",
      "description": "Case study for the Savani Jewellery ecommerce project covering Shopify, Web Development, SEO, and Integrations.",
      "image": "https://abox.agency/assets/image/portfolios/savani/savani1.webp",
      "keywords": [
        "Savani Jewellery",
        "Shopify",
        "Web Development",
        "SEO",
        "Integrations"
      ]
    }
  },
  "/portfolio/mia": {
    "title": "Mia My Inner Ally Shopify Case Study | Abox Agency",
    "description": "Mia My Inner Ally makes organic cotton sanitary pads for comfort and safety. Abox Agency built its Shopify site with branding, graphics, and SEO for a confident launch.",
    "url": "https://abox.agency/portfolio/mia",
    "image": "https://abox.agency/assets/image/portfolios/mia/mia1.jpg",
    "keywords": "Mia My Inner Ally, Abox Agency, feminine hygiene ecommerce, Shopify development, branding, SEO, portfolio case study",
    "brand": "Mia My Inner Ally",
    "services": [
      "Shopify",
      "Web Development",
      "SEO"
    ],
    "industry": "Feminine Hygiene Products",
    "schema": {
      "name": "Mia My Inner Ally Portfolio Project",
      "url": "https://abox.agency/portfolio/mia",
      "description": "Case study for the Mia My Inner Ally ecommerce project covering Shopify, Web Development, and SEO.",
      "image": "https://abox.agency/assets/image/portfolios/mia/mia1.jpg",
      "keywords": [
        "Mia My Inner Ally",
        "Shopify",
        "Web Development",
        "SEO"
      ]
    }
  },
  "/portfolio/ui/teatox-life": {
    "title": "TeaTox Life UI/UX Case Study | Abox Agency",
    "description": "For TeaTox Life's wellness platform, Abox Agency designed the UI/UX and wireframes from scratch, creating an engaging interface that mirrors the brand's calm identity.",
    "url": "https://abox.agency/portfolio/ui/teatox-life",
    "image": "https://abox.agency/assets/image/ui/teatoxlife/teatox1.webp",
    "keywords": "TeaTox Life UI/UX, Abox Agency, herbal wellness interface, UI design, UX design, wireframing, portfolio case study",
    "brand": "TeaTox Life",
    "services": [
      "UI Design",
      "UX Design",
      "Wireframing"
    ],
    "industry": "Herbal Tea & Wellness",
    "schema": {
      "name": "TeaTox Life Portfolio Project",
      "url": "https://abox.agency/portfolio/ui/teatox-life",
      "description": "Case study for the TeaTox Life UI/UX design project covering UI Design, UX Design, and Wireframing.",
      "image": "https://abox.agency/assets/image/ui/teatoxlife/teatox1.webp",
      "keywords": [
        "TeaTox Life",
        "UI Design",
        "UX Design",
        "Wireframing"
      ]
    }
  },
  "/portfolio/ui/apple-elevators": {
    "title": "Apple Elevators UI/UX Case Study | Abox Agency",
    "description": "Apple Elevators needed a site that reflects decades of engineering expertise. Abox Agency designed custom UI/UX with wireframes built around its product range.",
    "url": "https://abox.agency/portfolio/ui/apple-elevators",
    "image": "https://abox.agency/assets/image/og_images/apple_elevator.jpg",
    "keywords": "Apple Elevators UI/UX, Abox Agency, elevator company website, UI design, UX design, wireframing, portfolio case study",
    "brand": "Apple Elevators",
    "services": [
      "UI Design",
      "UX Design",
      "Wireframing"
    ],
    "industry": "Elevators & Escalators",
    "schema": {
      "name": "Apple Elevators Portfolio Project",
      "url": "https://abox.agency/portfolio/ui/apple-elevators",
      "description": "Case study for the Apple Elevators UI/UX design project covering UI Design, UX Design, and Wireframing.",
      "image": "https://abox.agency/assets/image/og_images/apple_elevator.jpg",
      "keywords": [
        "Apple Elevators",
        "UI Design",
        "UX Design",
        "Wireframing"
      ]
    }
  },
  "/portfolio/ui/healing-hands": {
    "title": "Healing Hands UI/UX Case Study | Abox Agency",
    "description": "Healing Hands needed an interface as trustworthy as its plant-based treatments. Abox Agency designed the UI/UX and wireframes for a sensitive, easy-to-navigate site.",
    "url": "https://abox.agency/portfolio/ui/healing-hands",
    "image": "https://abox.agency/assets/image/ui/healinghand/healing1.webp",
    "keywords": "Healing Hands UI/UX, Abox Agency, plant-based medicine interface, UI design, UX design, wireframing, portfolio case study",
    "brand": "Healing Hands",
    "services": [
      "UI Design",
      "UX Design",
      "Wireframing"
    ],
    "industry": "Piles & Digestive Care",
    "schema": {
      "name": "Healing Hands Portfolio Project",
      "url": "https://abox.agency/portfolio/ui/healing-hands",
      "description": "Case study for the Healing Hands UI/UX design project covering UI Design, UX Design, and Wireframing.",
      "image": "https://abox.agency/assets/image/ui/healinghand/healing1.webp",
      "keywords": [
        "Healing Hands",
        "UI Design",
        "UX Design",
        "Wireframing"
      ]
    }
  },
  "/portfolio/ui/the-one": {
    "title": "The One UI/UX Case Study | Abox Agency",
    "description": "The One is a Web3 platform for government-backed blockchain data. Abox Agency designed a custom UI/UX that makes complex blockchain governance easy to navigate.",
    "url": "https://abox.agency/portfolio/ui/the-one",
    "image": "https://abox.agency/assets/image/og_images/the_one.jpg",
    "keywords": "The One UI/UX, Abox Agency, blockchain governance interface, UI design, UX design, wireframing, portfolio case study",
    "brand": "The One",
    "services": [
      "UI Design",
      "UX Design",
      "Wireframing"
    ],
    "industry": "Government Blockchain Innovation",
    "schema": {
      "name": "The One Portfolio Project",
      "url": "https://abox.agency/portfolio/ui/the-one",
      "description": "Case study for the The One UI/UX design project covering UI Design, UX Design, and Wireframing.",
      "image": "https://abox.agency/assets/image/og_images/the_one.jpg",
      "keywords": [
        "The One",
        "UI Design",
        "UX Design",
        "Wireframing"
      ]
    }
  },
  "/portfolio/ui/lycanpay": {
    "title": "Lycan Pay UI/UX Case Study | Abox Agency",
    "description": "Lycan Pay is reshaping payments with blockchain technology. Abox Agency designed a secure, intuitive UI/UX and wireframes built for fast, trustworthy transactions.",
    "url": "https://abox.agency/portfolio/ui/lycanpay",
    "image": "https://abox.agency/assets/image/og_images/lycan_pay.jpg",
    "keywords": "Lycan Pay UI/UX, Abox Agency, blockchain payments interface, UI design, UX design, wireframing, portfolio case study",
    "brand": "Lycan Pay",
    "services": [
      "UI Design",
      "UX Design",
      "Wireframing"
    ],
    "industry": "Digital Payments & Fintech",
    "schema": {
      "name": "Lycan Pay Portfolio Project",
      "url": "https://abox.agency/portfolio/ui/lycanpay",
      "description": "Case study for the Lycan Pay UI/UX design project covering UI Design, UX Design, and Wireframing.",
      "image": "https://abox.agency/assets/image/og_images/lycan_pay.jpg",
      "keywords": [
        "Lycan Pay",
        "UI Design",
        "UX Design",
        "Wireframing"
      ]
    }
  },
  "/portfolio/label/aumex": {
    "title": "Aumex 3D Design Case Study | Abox Agency",
    "description": "For Aumex's intimate care range, Abox Agency created 3D renders, packaging, and infographics that keep the brand's care-focused message front and centre.",
    "url": "https://abox.agency/portfolio/label/aumex",
    "image": "https://abox.agency/assets/image/label/aumex/aumex1.webp",
    "keywords": "Aumex 3D, Abox Agency, intimate hygiene packaging, 3D rendering, packaging design, infographics, portfolio case study",
    "brand": "Aumex",
    "services": [
      "3D Rendering",
      "Packaging",
      "Graphic Design",
      "Infographics"
    ],
    "industry": "Intimate Hygiene & Personal Care",
    "schema": {
      "name": "Aumex Portfolio Project",
      "url": "https://abox.agency/portfolio/label/aumex",
      "description": "Case study for the Aumex 3D product design project covering 3D Rendering, Packaging, Graphic Design, and Infographics.",
      "image": "https://abox.agency/assets/image/label/aumex/aumex1.webp",
      "keywords": [
        "Aumex",
        "3D Rendering",
        "Packaging",
        "Graphic Design",
        "Infographics"
      ]
    }
  },
  "/portfolio/label/shishtaka": {
    "title": "Shishtaka 3D Design Case Study | Abox Agency",
    "description": "Shishtaka's herbal teas needed packaging that told a story of resilience. Abox Agency produced 3D models, unique designs, and infographics for the eCommerce launch.",
    "url": "https://abox.agency/portfolio/label/shishtaka",
    "image": "https://abox.agency/assets/image/label/shishtaka/shishtaka1.webp",
    "keywords": "Shishtaka 3D, Abox Agency, herbal tea packaging, 3D rendering, packaging design, infographics, portfolio case study",
    "brand": "Shishtaka",
    "services": [
      "3D Rendering",
      "Packaging",
      "Graphic Design",
      "Infographics"
    ],
    "industry": "Herbal Tea & Wellness",
    "schema": {
      "name": "Shishtaka Portfolio Project",
      "url": "https://abox.agency/portfolio/label/shishtaka",
      "description": "Case study for the Shishtaka 3D product design project covering 3D Rendering, Packaging, Graphic Design, and Infographics.",
      "image": "https://abox.agency/assets/image/label/shishtaka/shishtaka1.webp",
      "keywords": [
        "Shishtaka",
        "3D Rendering",
        "Packaging",
        "Graphic Design",
        "Infographics"
      ]
    }
  },
  "/portfolio/label/naturare": {
    "title": "Naturare 3D Design Case Study | Abox Agency",
    "description": "Naturare's product line needed visuals as natural as its ingredients. Abox Agency delivered 3D rendering, packaging, and infographics across its wellness range.",
    "url": "https://abox.agency/portfolio/label/naturare",
    "image": "https://abox.agency/assets/image/label/naturare/naturare1.webp",
    "keywords": "Naturare 3D, Abox Agency, wellness product packaging, 3D rendering, packaging design, infographics, portfolio case study",
    "brand": "Naturare",
    "services": [
      "3D Rendering",
      "Packaging",
      "Graphic Design",
      "Infographics"
    ],
    "industry": "Natural Wellness Products",
    "schema": {
      "name": "Naturare Portfolio Project",
      "url": "https://abox.agency/portfolio/label/naturare",
      "description": "Case study for the Naturare 3D product design project covering 3D Rendering, Packaging, Graphic Design, and Infographics.",
      "image": "https://abox.agency/assets/image/label/naturare/naturare1.webp",
      "keywords": [
        "Naturare",
        "3D Rendering",
        "Packaging",
        "Graphic Design",
        "Infographics"
      ]
    }
  },
  "/portfolio/label/teatox-life": {
    "title": "TeaTox Life 3D Design Case Study | Abox Agency",
    "description": "Abox Agency designed TeaTox Life's product packaging, 3D models, and infographics, giving its herbal teas a premium look built for the global wellness market.",
    "url": "https://abox.agency/portfolio/label/teatox-life",
    "image": "https://abox.agency/assets/image/label/teatoxlife/teatoxlife1.webp",
    "keywords": "TeaTox Life 3D, Abox Agency, herbal tea packaging, 3D rendering, packaging design, infographics, portfolio case study",
    "brand": "TeaTox Life",
    "services": [
      "3D Rendering",
      "Packaging",
      "Graphic Design",
      "Infographics"
    ],
    "industry": "Herbal Tea & Wellness",
    "schema": {
      "name": "TeaTox Life Portfolio Project",
      "url": "https://abox.agency/portfolio/label/teatox-life",
      "description": "Case study for the TeaTox Life 3D product design project covering 3D Rendering, Packaging, Graphic Design, and Infographics.",
      "image": "https://abox.agency/assets/image/label/teatoxlife/teatoxlife1.webp",
      "keywords": [
        "TeaTox Life",
        "3D Rendering",
        "Packaging",
        "Graphic Design",
        "Infographics"
      ]
    }
  },
  "/portfolio/label/healing-hands": {
    "title": "Healing Hands 3D Design Case Study | Abox Agency",
    "description": "From bottles to sprays, Healing Hands needed consistent product visuals across its range. Abox Agency delivered 3D rendering, packaging, and infographics throughout.",
    "url": "https://abox.agency/portfolio/label/healing-hands",
    "image": "https://abox.agency/assets/image/label/healinghands/healinghands1.jpg",
    "keywords": "Healing Hands 3D, Abox Agency, medical product packaging, 3D rendering, packaging design, infographics, portfolio case study",
    "brand": "Healing Hands",
    "services": [
      "3D Rendering",
      "Packaging",
      "Graphic Design",
      "Infographics"
    ],
    "industry": "Medical & Healthcare Products",
    "schema": {
      "name": "Healing Hands Portfolio Project",
      "url": "https://abox.agency/portfolio/label/healing-hands",
      "description": "Case study for the Healing Hands 3D product design project covering 3D Rendering, Packaging, Graphic Design, and Infographics.",
      "image": "https://abox.agency/assets/image/label/healinghands/healinghands1.jpg",
      "keywords": [
        "Healing Hands",
        "3D Rendering",
        "Packaging",
        "Graphic Design",
        "Infographics"
      ]
    }
  },
  "/portfolio/label/mypro": {
    "title": "My Pro Sport Nutritions 3D Design Case Study | Abox Agency",
    "description": "My Pro Sport Nutritions needed visuals that speak to serious athletes. Abox Agency built 3D models, renders, and infographics to elevate its label design.",
    "url": "https://abox.agency/portfolio/label/mypro",
    "image": "https://abox.agency/assets/image/label/mypro/mypro1.webp",
    "keywords": "My Pro 3D, Abox Agency, sports supplement packaging, 3D rendering, packaging design, infographics, portfolio case study",
    "brand": "My Pro Sport Nutritions",
    "services": [
      "3D Rendering",
      "Packaging",
      "Graphic Design",
      "Infographics"
    ],
    "industry": "Sports Nutrition & Supplements",
    "schema": {
      "name": "My Pro Sport Nutritions Portfolio Project",
      "url": "https://abox.agency/portfolio/label/mypro",
      "description": "Case study for the My Pro Sport Nutritions 3D product design project covering 3D Rendering, Packaging, Graphic Design, and Infographics.",
      "image": "https://abox.agency/assets/image/label/mypro/mypro1.webp",
      "keywords": [
        "My Pro Sport Nutritions",
        "3D Rendering",
        "Packaging",
        "Graphic Design",
        "Infographics"
      ]
    }
  },
  "/portfolio/label/acnex-topical": {
    "title": "Acne-X 3D Design Case Study | Abox Agency",
    "description": "Acne-X needed lifelike product visuals for its acne-care line. Abox Agency created detailed 3D renders and product modeling with realistic texture and lighting.",
    "url": "https://abox.agency/portfolio/label/acnex-topical",
    "image": "https://abox.agency/assets/image/label/acnex/acnex1.jpg",
    "keywords": "Acne-X 3D, Abox Agency, skincare product rendering, 3D rendering, product modeling, product visualization, portfolio case study",
    "brand": "Acne-X",
    "services": [
      "3D Rendering",
      "Product Modeling",
      "Product Visualization"
    ],
    "industry": "Skincare & Beauty",
    "schema": {
      "name": "Acne-X Portfolio Project",
      "url": "https://abox.agency/portfolio/label/acnex-topical",
      "description": "Case study for the Acne-X 3D product design project covering 3D Rendering, Product Modeling, and Product Visualization.",
      "image": "https://abox.agency/assets/image/label/acnex/acnex1.jpg",
      "keywords": [
        "Acne-X",
        "3D Rendering",
        "Product Modeling",
        "Product Visualization"
      ]
    }
  },
  "/portfolio/label/anthi-naturals": {
    "title": "Anthi 3D Design Case Study | Abox Agency",
    "description": "Anthi is India's first anti-thinning hair care brand. Abox Agency created realistic 3D renders and mockups for its serum bottle, highlighting natural ingredients.",
    "url": "https://abox.agency/portfolio/label/anthi-naturals",
    "image": "https://abox.agency/assets/image/label/label-anthi/anthi1.jpg",
    "keywords": "Anthi 3D, Abox Agency, hair care product rendering, 3D rendering, product modeling, product visualization, portfolio case study",
    "brand": "Anthi",
    "services": [
      "3D Rendering",
      "Product Modeling",
      "Product Visualization"
    ],
    "industry": "Hair Care",
    "schema": {
      "name": "Anthi Portfolio Project",
      "url": "https://abox.agency/portfolio/label/anthi-naturals",
      "description": "Case study for the Anthi 3D product design project covering 3D Rendering, Product Modeling, and Product Visualization.",
      "image": "https://abox.agency/assets/image/label/label-anthi/anthi1.jpg",
      "keywords": [
        "Anthi",
        "3D Rendering",
        "Product Modeling",
        "Product Visualization"
      ]
    }
  },
  "/portfolio/label/terahash-solutions": {
    "title": "Terahash Solutions 3D Design Case Study | Abox Agency",
    "description": "Terahash Solutions builds ASIC crypto mining hardware. Abox Agency created realistic 3D renders that showcase the technology and detail behind every miner.",
    "url": "https://abox.agency/portfolio/label/terahash-solutions",
    "image": "https://abox.agency/assets/image/label/terahash/terahash1.jpg",
    "keywords": "Terahash Solutions 3D, Abox Agency, crypto mining hardware rendering, 3D rendering, product modeling, portfolio case study",
    "brand": "Terahash Solutions",
    "services": [
      "3D Rendering",
      "Product Modeling",
      "Product Visualization"
    ],
    "industry": "Crypto Mining Hardware",
    "schema": {
      "name": "Terahash Solutions Portfolio Project",
      "url": "https://abox.agency/portfolio/label/terahash-solutions",
      "description": "Case study for the Terahash Solutions 3D product design project covering 3D Rendering, Product Modeling, and Product Visualization.",
      "image": "https://abox.agency/assets/image/label/terahash/terahash1.jpg",
      "keywords": [
        "Terahash Solutions",
        "3D Rendering",
        "Product Modeling",
        "Product Visualization"
      ]
    }
  },
  "/portfolio/label/ras-lipstick": {
    "title": "RAS Lipstick 3D Design Case Study | Abox Agency",
    "description": "RAS Luxury's eco-friendly lipstick line needed a premium look. Abox Agency created photorealistic 3D renders that showcase its elegant, sustainable design.",
    "url": "https://abox.agency/portfolio/label/ras-lipstick",
    "image": "https://abox.agency/assets/image/label/ras/ras9.jpg",
    "keywords": "RAS Lipstick 3D, Abox Agency, luxury cosmetics rendering, 3D rendering, product modeling, product visualization, portfolio case study",
    "brand": "RAS Lipstick",
    "services": [
      "3D Rendering",
      "Product Modeling",
      "Product Visualization"
    ],
    "industry": "Luxury Beauty & Cosmetics",
    "schema": {
      "name": "RAS Lipstick Portfolio Project",
      "url": "https://abox.agency/portfolio/label/ras-lipstick",
      "description": "Case study for the RAS Lipstick 3D product design project covering 3D Rendering, Product Modeling, and Product Visualization.",
      "image": "https://abox.agency/assets/image/label/ras/ras9.jpg",
      "keywords": [
        "RAS Lipstick",
        "3D Rendering",
        "Product Modeling",
        "Product Visualization"
      ]
    }
  },
  "/portfolio/label/smart-mop": {
    "title": "Caspian 3D Design Case Study | Abox Agency",
    "description": "Caspian's Smart Mop needed visuals that highlight its eco-friendly, innovative design. Abox Agency produced 3D renders that boosted brand presence and engagement.",
    "url": "https://abox.agency/portfolio/label/smart-mop",
    "image": "https://abox.agency/assets/image/label/caspian/caspian1.jpg",
    "keywords": "Caspian 3D, Abox Agency, home appliance rendering, 3D rendering, product modeling, product presentation, portfolio case study",
    "brand": "Caspian",
    "services": [
      "3D Rendering",
      "Product Modeling",
      "Product Presentation"
    ],
    "industry": "Home Appliances",
    "schema": {
      "name": "Caspian Portfolio Project",
      "url": "https://abox.agency/portfolio/label/smart-mop",
      "description": "Case study for the Caspian 3D product design project covering 3D Rendering, Product Modeling, and Product Presentation.",
      "image": "https://abox.agency/assets/image/label/caspian/caspian1.jpg",
      "keywords": [
        "Caspian",
        "3D Rendering",
        "Product Modeling",
        "Product Presentation"
      ]
    }
  },
  "/portfolio/label/kayura-effect": {
    "title": "Kayura 3D Design Case Study | Abox Agency",
    "description": "Kayura's skincare packaging needed lifelike detail across round and oval bottles. Abox Agency delivered 3D renders with careful texture work for its online store.",
    "url": "https://abox.agency/portfolio/label/kayura-effect",
    "image": "https://abox.agency/assets/image/label/kayura/kayura1.jpg",
    "keywords": "Kayura 3D, Abox Agency, skincare packaging rendering, 3D rendering, 3D modeling, product visualization, portfolio case study",
    "brand": "Kayura",
    "services": [
      "3D Rendering",
      "3D Modeling",
      "Product Visualization"
    ],
    "industry": "Skincare & Cosmetics",
    "schema": {
      "name": "Kayura Portfolio Project",
      "url": "https://abox.agency/portfolio/label/kayura-effect",
      "description": "Case study for the Kayura 3D product design project covering 3D Rendering, 3D Modeling, and Product Visualization.",
      "image": "https://abox.agency/assets/image/label/kayura/kayura1.jpg",
      "keywords": [
        "Kayura",
        "3D Rendering",
        "3D Modeling",
        "Product Visualization"
      ]
    }
  },
  "/portfolio/label/kutum-ayurveda": {
    "title": "Kutum Ayurveda 3D Design Case Study | Abox Agency",
    "description": "Kutum Ayurveda's organic products needed visuals that carry ancient wisdom into a modern market. Abox Agency guided the 3D design from concept through execution.",
    "url": "https://abox.agency/portfolio/label/kutum-ayurveda",
    "image": "https://abox.agency/assets/image/label/kutum/kutum1.jpg",
    "keywords": "Kutum Ayurveda 3D, Abox Agency, Ayurvedic product rendering, 3D rendering, product modeling, portfolio case study",
    "brand": "Kutum Ayurveda",
    "services": [
      "3D Rendering",
      "Product Modeling",
      "Product Visualization"
    ],
    "industry": "Ayurvedic Skincare",
    "schema": {
      "name": "Kutum Ayurveda Portfolio Project",
      "url": "https://abox.agency/portfolio/label/kutum-ayurveda",
      "description": "Case study for the Kutum Ayurveda 3D product design project covering 3D Rendering, Product Modeling, and Product Visualization.",
      "image": "https://abox.agency/assets/image/label/kutum/kutum1.jpg",
      "keywords": [
        "Kutum Ayurveda",
        "3D Rendering",
        "Product Modeling",
        "Product Visualization"
      ]
    }
  },
  "/portfolio/label/maadico": {
    "title": "Maadico Wellness 3D Design Case Study | Abox Agency",
    "description": "Maadico Wellness needed lifelike visuals for its herbal pouches and bottles. Abox Agency delivered 3D rendering and modeling that strengthened its branding and marketing.",
    "url": "https://abox.agency/portfolio/label/maadico",
    "image": "https://abox.agency/assets/image/label/maadico/maadico1.jpg",
    "keywords": "Maadico Wellness 3D, Abox Agency, herbal product rendering, 3D rendering, product modeling, portfolio case study",
    "brand": "Maadico Wellness",
    "services": [
      "3D Rendering",
      "Product Modeling",
      "Product Visualization"
    ],
    "industry": "Herbal Wellness Products",
    "schema": {
      "name": "Maadico Wellness Portfolio Project",
      "url": "https://abox.agency/portfolio/label/maadico",
      "description": "Case study for the Maadico Wellness 3D product design project covering 3D Rendering, Product Modeling, and Product Visualization.",
      "image": "https://abox.agency/assets/image/label/maadico/maadico1.jpg",
      "keywords": [
        "Maadico Wellness",
        "3D Rendering",
        "Product Modeling",
        "Product Visualization"
      ]
    }
  },
  "/portfolio/label/maison-de-jarin": {
    "title": "Maison De Jarin 3D Design Case Study | Abox Agency",
    "description": "Maison De Jarin sells handcrafted tea blends for the adventurous soul. Abox Agency created detailed 3D renders of its boxes and sachets with vibrant, lifelike textures.",
    "url": "https://abox.agency/portfolio/label/maison-de-jarin",
    "image": "https://abox.agency/assets/image/label/maisonjarin/maisonjarin1.jpg",
    "keywords": "Maison De Jarin 3D, Abox Agency, tea packaging rendering, 3D rendering, product modeling, texturing, portfolio case study",
    "brand": "Maison De Jarin",
    "services": [
      "3D Rendering",
      "Product Modeling",
      "Texturing"
    ],
    "industry": "Handcrafted Teas",
    "schema": {
      "name": "Maison De Jarin Portfolio Project",
      "url": "https://abox.agency/portfolio/label/maison-de-jarin",
      "description": "Case study for the Maison De Jarin 3D product design project covering 3D Rendering, Product Modeling, and Texturing.",
      "image": "https://abox.agency/assets/image/label/maisonjarin/maisonjarin1.jpg",
      "keywords": [
        "Maison De Jarin",
        "3D Rendering",
        "Product Modeling",
        "Texturing"
      ]
    }
  },
  "/portfolio/label/molecule": {
    "title": "Molecule 53 3D Design Case Study | Abox Agency",
    "description": "Molecule 53 is a science-backed luxury skincare brand. Abox Agency created realistic 3D renders and product models to showcase it across every platform.",
    "url": "https://abox.agency/portfolio/label/molecule",
    "image": "https://abox.agency/assets/image/label/molecule/molecule1.jpg",
    "keywords": "Molecule 53 3D, Abox Agency, luxury skincare rendering, 3D rendering, product modeling, product visualization, portfolio case study",
    "brand": "Molecule 53",
    "services": [
      "3D Rendering",
      "Product Modeling",
      "Product Visualization"
    ],
    "industry": "Luxury Skincare",
    "schema": {
      "name": "Molecule 53 Portfolio Project",
      "url": "https://abox.agency/portfolio/label/molecule",
      "description": "Case study for the Molecule 53 3D product design project covering 3D Rendering, Product Modeling, and Product Visualization.",
      "image": "https://abox.agency/assets/image/label/molecule/molecule1.jpg",
      "keywords": [
        "Molecule 53",
        "3D Rendering",
        "Product Modeling",
        "Product Visualization"
      ]
    }
  },
  "/portfolio/label/weight-manage": {
    "title": "Weight Manage 3D Design Case Study | Abox Agency",
    "description": "Weight Manage's supplement range needed packaging that stands out on shelf and screen. Abox Agency created sleek, modern box design to boost brand visibility.",
    "url": "https://abox.agency/portfolio/label/weight-manage",
    "image": "https://abox.agency/assets/image/label/weight_manage/weightmanage1.jpg",
    "keywords": "Weight Manage 3D, Abox Agency, supplement packaging design, packaging design, product branding, box design, portfolio case study",
    "brand": "Weight Manage",
    "services": [
      "Packaging Design",
      "Product Branding",
      "Box Design"
    ],
    "industry": "Health & Wellness",
    "schema": {
      "name": "Weight Manage Portfolio Project",
      "url": "https://abox.agency/portfolio/label/weight-manage",
      "description": "Case study for the Weight Manage 3D product design project covering Packaging Design, Product Branding, and Box Design.",
      "image": "https://abox.agency/assets/image/label/weight_manage/weightmanage1.jpg",
      "keywords": [
        "Weight Manage",
        "Packaging Design",
        "Product Branding",
        "Box Design"
      ]
    }
  },
  "/portfolio/branding/abox": {
    "title": "Our Brand Identity Case Study | Abox Agency",
    "description": "Abox Agency's own visual identity needed to match its creative work. Explore our brand strategy, collateral, and customer experience process, applied to ourselves first.",
    "url": "https://abox.agency/portfolio/branding/abox",
    "image": "https://abox.agency/assets/image/portfolios/abox/abox1.webp",
    "keywords": "Abox Agency, brand identity, brand strategy, brand collateral, digital agency branding, portfolio case study",
    "brand": "Abox Agency",
    "services": [
      "Visual Identity",
      "Brand Strategy",
      "Brand Collateral"
    ],
    "industry": "Digital Agency Branding",
    "schema": {
      "name": "Abox Agency Portfolio Project",
      "url": "https://abox.agency/portfolio/branding/abox",
      "description": "Case study for the Abox Agency branding project covering Visual Identity, Brand Strategy, and Brand Collateral.",
      "image": "https://abox.agency/assets/image/portfolios/abox/abox1.webp",
      "keywords": [
        "Abox Agency",
        "Visual Identity",
        "Brand Strategy",
        "Brand Collateral"
      ]
    }
  },
  "/portfolio/branding/nourysh": {
    "title": "Nourysh Branding Case Study | Abox Agency",
    "description": "Nourysh needed a brand identity as science-backed as its supplements. Abox Agency built a new logo, guidelines, and 3D visuals that strengthened its wellness positioning.",
    "url": "https://abox.agency/portfolio/branding/nourysh",
    "image": "https://abox.agency/assets/image/portfolios/nourysh_branding/nourysh1.webp",
    "keywords": "Nourysh branding, Abox Agency, health supplement brand identity, brand strategy, brand collateral, portfolio case study",
    "brand": "Nourysh",
    "services": [
      "Visual Identity",
      "Brand Strategy",
      "Brand Collateral"
    ],
    "industry": "Health & Wellness Supplements",
    "schema": {
      "name": "Nourysh Portfolio Project",
      "url": "https://abox.agency/portfolio/branding/nourysh",
      "description": "Case study for the Nourysh branding project covering Visual Identity, Brand Strategy, and Brand Collateral.",
      "image": "https://abox.agency/assets/image/portfolios/nourysh_branding/nourysh1.webp",
      "keywords": [
        "Nourysh",
        "Visual Identity",
        "Brand Strategy",
        "Brand Collateral"
      ]
    }
  },
  "/portfolio/branding/terahash-solutions": {
    "title": "Terahash Solutions Branding Case Study | Abox Agency",
    "description": "Terahash Solutions needed a brand refresh for the Bitcoin mining industry. Abox Agency built a bold logo, cohesive guidelines, and 3D visuals for its market presence.",
    "url": "https://abox.agency/portfolio/branding/terahash-solutions",
    "image": "https://abox.agency/assets/image/portfolios/terahash_brand/terahash1.webp",
    "keywords": "Terahash Solutions branding, Abox Agency, crypto mining brand identity, brand strategy, brand collateral, portfolio case study",
    "brand": "Terahash Solutions",
    "services": [
      "Visual Identity",
      "Brand Strategy",
      "Brand Collateral"
    ],
    "industry": "Crypto Mining Hardware",
    "schema": {
      "name": "Terahash Solutions Portfolio Project",
      "url": "https://abox.agency/portfolio/branding/terahash-solutions",
      "description": "Case study for the Terahash Solutions branding project covering Visual Identity, Brand Strategy, and Brand Collateral.",
      "image": "https://abox.agency/assets/image/portfolios/terahash_brand/terahash1.webp",
      "keywords": [
        "Terahash Solutions",
        "Visual Identity",
        "Brand Strategy",
        "Brand Collateral"
      ]
    }
  },
  "/portfolio/terahash-solutions": {
    "title": "Terahash Solutions Webflow Case Study | Abox Agency",
    "description": "Terahash Solutions needed a website that matched the pace of crypto mining tech. Abox Agency built a sleek Webflow site with UI/UX design and 3D renders.",
    "url": "https://abox.agency/portfolio/terahash-solutions",
    "image": "https://abox.agency/assets/image/portfolios/terahash/terahash1.webp",
    "keywords": "Terahash Solutions Webflow, Abox Agency, crypto mining website, Webflow development, UI/UX design, 3D rendering, portfolio case study",
    "brand": "Terahash Solutions",
    "services": [
      "Webflow Development",
      "UI/UX Design",
      "Logo Design",
      "3D Rendering"
    ],
    "industry": "Crypto Mining Devices",
    "schema": {
      "name": "Terahash Solutions Portfolio Project",
      "url": "https://abox.agency/portfolio/terahash-solutions",
      "description": "Case study for the Terahash Solutions Webflow website project covering Webflow Development, UI/UX Design, Logo Design, and 3D Rendering.",
      "image": "https://abox.agency/assets/image/portfolios/terahash/terahash1.webp",
      "keywords": [
        "Terahash Solutions",
        "Webflow Development",
        "UI/UX Design",
        "Logo Design",
        "3D Rendering"
      ]
    }
  },
  "/portfolio/codifi": {
    "title": "Codifi Webflow Case Study | Abox Agency",
    "description": "Codifi builds financial software for Indian field teams. Abox Agency built a new Webflow site with UI/UX design and on-site SEO to boost efficiency and reach.",
    "url": "https://abox.agency/portfolio/codifi",
    "image": "https://abox.agency/assets/image/portfolios/codifi/codifi1.webp",
    "keywords": "Codifi, Abox Agency, fintech website, Webflow development, UI/UX design, on-site SEO, portfolio case study",
    "brand": "Codifi",
    "services": [
      "Webflow Development",
      "UI/UX Design",
      "Logo Design",
      "On-Site SEO"
    ],
    "industry": "Field Data Management Software",
    "schema": {
      "name": "Codifi Portfolio Project",
      "url": "https://abox.agency/portfolio/codifi",
      "description": "Case study for the Codifi Webflow website project covering Webflow Development, UI/UX Design, Logo Design, and On-Site SEO.",
      "image": "https://abox.agency/assets/image/portfolios/codifi/codifi1.webp",
      "keywords": [
        "Codifi",
        "Webflow Development",
        "UI/UX Design",
        "Logo Design",
        "On-Site SEO"
      ]
    }
  },
  "/portfolio/paperclip-and-co": {
    "title": "Paperclip & Co Webflow Case Study | Abox Agency",
    "description": "Paperclip & Co champions women's creativity through social campaigns. Abox Agency built a custom site with UI/UX and brand design that amplifies its mission.",
    "url": "https://abox.agency/portfolio/paperclip-and-co",
    "image": "https://abox.agency/assets/image/portfolios/paperclip/paperclip1.webp",
    "keywords": "Paperclip & Co, Abox Agency, social media agency website, custom development, UI/UX design, brand design, portfolio case study",
    "brand": "Paperclip & Co",
    "services": [
      "Custom Development",
      "UI/UX Design",
      "Brand Design"
    ],
    "industry": "Social Media & Brand Identity",
    "schema": {
      "name": "Paperclip & Co Portfolio Project",
      "url": "https://abox.agency/portfolio/paperclip-and-co",
      "description": "Case study for the Paperclip & Co Webflow website project covering Custom Development, UI/UX Design, and Brand Design.",
      "image": "https://abox.agency/assets/image/portfolios/paperclip/paperclip1.webp",
      "keywords": [
        "Paperclip & Co",
        "Custom Development",
        "UI/UX Design",
        "Brand Design"
      ]
    }
  },
  "/portfolio/fone-network": {
    "title": "Fone Network React JS Case Study | Abox Agency",
    "description": "Fone Network brings blockchain and NFT staking to mobile. Abox Agency built a React JS platform with branding and on-site SEO for this Web3 innovator.",
    "url": "https://abox.agency/portfolio/fone-network",
    "image": "https://abox.agency/assets/image/portfolios/fone/fone1.webp",
    "keywords": "Fone Network, Abox Agency, Web3 website, React JS development, branding, on-site SEO, portfolio case study",
    "brand": "Fone Network",
    "services": [
      "React JS Development",
      "UI/UX Design",
      "Branding",
      "On-Site SEO"
    ],
    "industry": "Web3 & Blockchain Technology",
    "schema": {
      "name": "Fone Network Portfolio Project",
      "url": "https://abox.agency/portfolio/fone-network",
      "description": "Case study for the Fone Network website development project covering React JS Development, UI/UX Design, Branding, and On-Site SEO.",
      "image": "https://abox.agency/assets/image/portfolios/fone/fone1.webp",
      "keywords": [
        "Fone Network",
        "React JS Development",
        "UI/UX Design",
        "Branding",
        "On-Site SEO"
      ]
    }
  },
  "/portfolio/dl-films": {
    "title": "DL Films React JS Case Study | Abox Agency",
    "description": "DL Films tells stories through photography and cinematography. Abox Agency built a React JS portfolio site with branding and SEO fit for visual storytelling.",
    "url": "https://abox.agency/portfolio/dl-films",
    "image": "https://abox.agency/assets/image/portfolios/dlfilm/dlfilm2.webp",
    "keywords": "DL Films, Abox Agency, photography portfolio website, React JS development, branding, on-site SEO, portfolio case study",
    "brand": "DL Films",
    "services": [
      "React JS Development",
      "UI/UX Design",
      "Branding"
    ],
    "industry": "Photography & Videography",
    "schema": {
      "name": "DL Films Portfolio Project",
      "url": "https://abox.agency/portfolio/dl-films",
      "description": "Case study for the DL Films website development project covering React JS Development, UI/UX Design, and Branding.",
      "image": "https://abox.agency/assets/image/portfolios/dlfilm/dlfilm2.webp",
      "keywords": [
        "DL Films",
        "React JS Development",
        "UI/UX Design",
        "Branding"
      ]
    }
  },
  "/portfolio/aurolab": {
    "title": "AuroLab Web Dev Case Study | Abox Agency",
    "description": "AuroLab is a global leader in ophthalmic healthcare. Abox Agency built a Next.js site with SEO and integrations that simplify complex medical information.",
    "url": "https://abox.agency/portfolio/aurolab",
    "image": "https://abox.agency/assets/image/portfolios/aurolab/aurolab1.webp",
    "keywords": "AuroLab, Abox Agency, ophthalmic healthcare website, Next.js development, SEO, integrations, portfolio case study",
    "brand": "AuroLab",
    "services": [
      "Web Development",
      "SEO",
      "Next.js",
      "Integrations"
    ],
    "industry": "Ophthalmic Healthcare Solutions",
    "schema": {
      "name": "AuroLab Portfolio Project",
      "url": "https://abox.agency/portfolio/aurolab",
      "description": "Case study for the AuroLab website development project covering Web Development, SEO, Next.js, and Integrations.",
      "image": "https://abox.agency/assets/image/portfolios/aurolab/aurolab1.webp",
      "keywords": [
        "AuroLab",
        "Web Development",
        "SEO",
        "Next.js",
        "Integrations"
      ]
    }
  },
  "/portfolio/fast-n-fry": {
    "title": "Fast n Fry WordPress Case Study | Abox Agency",
    "description": "Fast n Fry manufactures premium potato and frozen snacks. Abox Agency rebuilt its site on WordPress with fresh branding and UI/UX to revitalize its online presence.",
    "url": "https://abox.agency/portfolio/fast-n-fry",
    "image": "https://abox.agency/assets/image/portfolios/fastfry/fastfry1.webp",
    "keywords": "Fast n Fry, Abox Agency, frozen snacks manufacturer website, WordPress development, branding, portfolio case study",
    "brand": "Fast n Fry",
    "services": [
      "WordPress Development",
      "UI/UX Design",
      "Branding"
    ],
    "industry": "Frozen Snacks Manufacturing",
    "schema": {
      "name": "Fast n Fry Portfolio Project",
      "url": "https://abox.agency/portfolio/fast-n-fry",
      "description": "Case study for the Fast n Fry website development project covering WordPress Development, UI/UX Design, and Branding.",
      "image": "https://abox.agency/assets/image/portfolios/fastfry/fastfry1.webp",
      "keywords": [
        "Fast n Fry",
        "WordPress Development",
        "UI/UX Design",
        "Branding"
      ]
    }
  },
  "/portfolio/greenfay": {
    "title": "Greenfay WordPress Case Study | Abox Agency",
    "description": "Greenfay champions premium potato farming and community empowerment. Abox Agency built its WordPress site with new branding and logo design for the agri-business.",
    "url": "https://abox.agency/portfolio/greenfay",
    "image": "https://abox.agency/assets/image/portfolios/greenfay/greenfay1.webp",
    "keywords": "Greenfay, Abox Agency, agri-business website, WordPress development, branding, logo design, portfolio case study",
    "brand": "Greenfay",
    "services": [
      "WordPress Development",
      "Branding",
      "Logo Design"
    ],
    "industry": "Agri-Business & Farming",
    "schema": {
      "name": "Greenfay Portfolio Project",
      "url": "https://abox.agency/portfolio/greenfay",
      "description": "Case study for the Greenfay website development project covering WordPress Development, Branding, and Logo Design.",
      "image": "https://abox.agency/assets/image/portfolios/greenfay/greenfay1.webp",
      "keywords": [
        "Greenfay",
        "WordPress Development",
        "Branding",
        "Logo Design"
      ]
    }
  },
  "/portfolio/westerville": {
    "title": "Westerville WordPress Case Study | Abox Agency",
    "description": "Westerville needed a patient-friendly dental website with clear information and online booking. Abox Agency built it on WordPress with fresh UI/UX and branding.",
    "url": "https://abox.agency/portfolio/westerville",
    "image": "https://abox.agency/assets/image/portfolios/westerville/westerville1.webp",
    "keywords": "Westerville, Abox Agency, dental practice website, WordPress development, UI/UX design, branding, portfolio case study",
    "brand": "Westerville",
    "services": [
      "WordPress Development",
      "UI/UX Design",
      "Branding"
    ],
    "industry": "Dentistry & Oral Health",
    "schema": {
      "name": "Westerville Portfolio Project",
      "url": "https://abox.agency/portfolio/westerville",
      "description": "Case study for the Westerville website development project covering WordPress Development, UI/UX Design, and Branding.",
      "image": "https://abox.agency/assets/image/portfolios/westerville/westerville1.webp",
      "keywords": [
        "Westerville",
        "WordPress Development",
        "UI/UX Design",
        "Branding"
      ]
    }
  },
  "/portfolio/bodyart": {
    "title": "Body Art React JS Case Study | Abox Agency",
    "description": "Body Art offers electrostimulation fitness and body sculpting services. Abox Agency built a custom booking platform in React JS with combo bookings and integrations.",
    "url": "https://abox.agency/portfolio/bodyart",
    "image": "https://abox.agency/assets/image/portfolios/bodyart/bodyart1.jpg",
    "keywords": "Body Art, Abox Agency, fitness booking platform, React JS development, SEO, integrations, portfolio case study",
    "brand": "Body Art",
    "services": [
      "React JS Development",
      "SEO",
      "Integrations"
    ],
    "industry": "Fitness & Body Sculpting",
    "schema": {
      "name": "Body Art Portfolio Project",
      "url": "https://abox.agency/portfolio/bodyart",
      "description": "Case study for the Body Art website development project covering React JS Development, SEO, and Integrations.",
      "image": "https://abox.agency/assets/image/portfolios/bodyart/bodyart1.jpg",
      "keywords": [
        "Body Art",
        "React JS Development",
        "SEO",
        "Integrations"
      ]
    }
  },
  "/portfolio/fragstalk": {
    "title": "Fragstalk Shopify Case Study | WooCommerce Migration | Abox Agency",
    "description": "How we migrated Fragstalk from WooCommerce to Shopify with zero SKU loss — and rebuilt fragrance discovery for 90+ brands. 1,200+ orders in launch week.",
    "url": "https://abox.agency/portfolio/fragstalk",
    "image": "https://abox.agency/assets/image/shopify_funnle/fragstalk.webp",
    "keywords": "WooCommerce to Shopify migration, Shopify migration case study, fragrance ecommerce, Shopify custom development, India",
    "brand": "Fragstalk",
    "services": [
      "Shopify Migration",
      "Shopify Development",
      "UI/UX Design"
    ],
    "industry": "Fragrance & Perfume Retail",
    "schema": {
      "name": "Fragstalk Portfolio Project",
      "url": "https://abox.agency/portfolio/fragstalk",
      "description": "Case study for the Fragstalk ecommerce project covering Shopify Migration, Shopify Development, and UI/UX Design.",
      "image": "https://abox.agency/assets/image/shopify_funnle/fragstalk.webp",
      "keywords": [
        "Fragstalk",
        "Shopify Migration",
        "Shopify Development",
        "UI/UX Design"
      ]
    }
  },
  "/portfolio/anandhaas": {
    "title": "Shree Anandhaas Shopify Case Study | Mithai Ecommerce | Abox Agency",
    "description": "How we migrated Shree Anandhaas from WooCommerce to Shopify — local delivery, gifting systems, CRO product cards, and a custom cart for a 27-year mithai brand.",
    "url": "https://abox.agency/portfolio/anandhaas",
    "image": "https://abox.agency/assets/image/casestudy/anandhaas/device-preview.webp",
    "keywords": "WooCommerce to Shopify migration, Shopify migration case study, sweets ecommerce Shopify, Shree Anandhaas, Abox Agency",
    "brand": "Shree Anandhaas",
    "services": [
      "Shopify Migration",
      "Shopify Development",
      "CRO"
    ],
    "industry": "Traditional Sweets & Confectionery",
    "schema": {
      "name": "Shree Anandhaas Portfolio Project",
      "url": "https://abox.agency/portfolio/anandhaas",
      "description": "Case study for the Shree Anandhaas ecommerce project covering Shopify Migration, Shopify Development, and CRO.",
      "image": "https://abox.agency/assets/image/casestudy/anandhaas/device-preview.webp",
      "keywords": [
        "Shree Anandhaas",
        "Shopify Migration",
        "Shopify Development",
        "CRO"
      ]
    }
  },
  "/portfolio/fruzo": {
    "title": "Fruzo Shopify Case Study | Custom Store & Subscription Build",
    "description": "How abox.agency built Fruzo's full digital presence — 3D renders, Shopify UI/UX, custom development and a subscription bundle builder with reward tiers. Now converting at 4.5%.",
    "url": "https://abox.agency/portfolio/fruzo",
    "image": "https://abox.agency/assets/image/casestudy/fruzo/device-preview.png",
    "keywords": "shopify subscription bundle builder, custom shopify development agency, shopify store design and development, ecommerce ui ux design case study, shopify subscription setup, 3d product rendering for ecommerce, fruzo smoothie shopify store, dtc food and beverage shopify agency, freeze-dried smoothie brand website, subscription box packaging design, Abox Agency",
    "brand": "Fruzo",
    "services": [
      "Shopify Development",
      "UI/UX Design",
      "3D Rendering",
      "Subscriptions"
    ],
    "industry": "Food & Beverage (Freeze-Dried Smoothies)",
    "schema": {
      "name": "Fruzo Portfolio Project",
      "url": "https://abox.agency/portfolio/fruzo",
      "description": "Case study for the Fruzo ecommerce project covering Shopify Development, UI/UX Design, 3D Rendering, and Subscriptions.",
      "image": "https://abox.agency/assets/image/casestudy/fruzo/device-preview.png",
      "keywords": [
        "Fruzo",
        "Shopify Development",
        "UI/UX Design",
        "3D Rendering",
        "Subscriptions"
      ]
    }
  },
  "/portfolio/eustress": {
    "title": "Eustress Shopify Case Study | Streetwear Storefront | Abox Agency",
    "description": "How Abox built Eustress — an Indian streetwear label — with capsule merchandising, overlay components, and a Shopify store that never asks shoppers to leave the page.",
    "url": "https://abox.agency/portfolio/eustress",
    "image": "https://abox.agency/assets/image/casestudy/eustress/device-preview.png",
    "keywords": "Eustress case study, Shopify streetwear store, fashion ecommerce Shopify, capsule merchandising, Abox Agency",
    "brand": "Eustress",
    "services": [
      "Shopify Development",
      "UI/UX Design",
      "Branding"
    ],
    "industry": "Streetwear & Fashion",
    "schema": {
      "name": "Eustress Portfolio Project",
      "url": "https://abox.agency/portfolio/eustress",
      "description": "Case study for the Eustress ecommerce project covering Shopify Development, UI/UX Design, and Branding.",
      "image": "https://abox.agency/assets/image/casestudy/eustress/device-preview.png",
      "keywords": [
        "Eustress",
        "Shopify Development",
        "UI/UX Design",
        "Branding"
      ]
    }
  },
  "/portfolio/acer-electric": {
    "title": "Acer Electric Case Study | Next.js EV Storefront | Abox Agency",
    "description": "How Abox researched India's EV category, redesigned every Acer Electric template, and shipped a Next.js system for motorcycles, scooters and e-cycles — with a real deposit checkout.",
    "url": "https://abox.agency/portfolio/acer-electric",
    "image": "https://abox.agency/assets/image/casestudy/acer/device-preview.png",
    "keywords": "Acer Electric case study, EV website design, Next.js ecommerce, electric vehicle UX, Abox Agency",
    "brand": "Acer Electric",
    "services": [
      "UI/UX Design",
      "Next.js Development",
      "Branding"
    ],
    "industry": "Electric Vehicles",
    "schema": {
      "name": "Acer Electric Portfolio Project",
      "url": "https://abox.agency/portfolio/acer-electric",
      "description": "Case study for the Acer Electric ecommerce project covering UI/UX Design, Next.js Development, and Branding.",
      "image": "https://abox.agency/assets/image/casestudy/acer/device-preview.png",
      "keywords": [
        "Acer Electric",
        "UI/UX Design",
        "Next.js Development",
        "Branding"
      ]
    }
  },
  "/portfolio/waylon-smith": {
    "title": "Waylon Smith Shopify Case Study | Eyewear Configurator | Abox Agency",
    "description": "How Abox designed and built Waylon Smith — a bilingual Dutch eyewear store with an on-page lens configurator, AI product photography, and quiet luxury UX.",
    "url": "https://abox.agency/portfolio/waylon-smith",
    "image": "https://abox.agency/assets/image/casestudy/waylon-smith/device-preview.png",
    "keywords": "Waylon Smith case study, Shopify eyewear store, lens configurator, prescription eyewear ecommerce, Abox Agency",
    "brand": "Waylon Smith",
    "services": [
      "Shopify Development",
      "UI/UX Design",
      "Product Configurator"
    ],
    "industry": "Eyewear",
    "schema": {
      "name": "Waylon Smith Portfolio Project",
      "url": "https://abox.agency/portfolio/waylon-smith",
      "description": "Case study for the Waylon Smith ecommerce project covering Shopify Development, UI/UX Design, and Product Configurator.",
      "image": "https://abox.agency/assets/image/casestudy/waylon-smith/device-preview.png",
      "keywords": [
        "Waylon Smith",
        "Shopify Development",
        "UI/UX Design",
        "Product Configurator"
      ]
    }
  },
  "/portfolio/oval": {
    "title": "Oval Health Case Study | Telehealth Brand Identity | Abox Agency",
    "description": "How Abox built Oval Health's brand system — frosted packaging, capsule mark, 3D, film and website — for a telehealth model that sells medication at cost.",
    "url": "https://abox.agency/portfolio/oval",
    "image": "https://abox.agency/assets/image/casestudy/oval/ovel-1.avif",
    "keywords": "Oval Health case study, telehealth branding, pharmacy packaging design, frosted brand system, Abox Agency",
    "brand": "Oval Health",
    "services": [
      "Branding",
      "Packaging Design",
      "3D Rendering",
      "Website"
    ],
    "industry": "Telehealth & Pharmacy",
    "schema": {
      "name": "Oval Health Portfolio Project",
      "url": "https://abox.agency/portfolio/oval",
      "description": "Case study for the Oval Health ecommerce project covering Branding, Packaging Design, 3D Rendering, and Website.",
      "image": "https://abox.agency/assets/image/casestudy/oval/ovel-1.avif",
      "keywords": [
        "Oval Health",
        "Branding",
        "Packaging Design",
        "3D Rendering",
        "Website"
      ]
    }
  },
  "/portfolio/3d/ayurmedix": {
    "title": "Ayurmedix 3D Packaging Renders Case Study | Abox Agency",
    "description": "How Abox built Ayurmedix's 3D product library — dark PET tablet bottles, translucent 1L juice, printed cartons — modelled, lit and rendered as one consistent range.",
    "url": "https://abox.agency/portfolio/3d/ayurmedix",
    "image": "https://abox.agency/assets/image/casestudy/ayurmedix-3d/ayurmedix-hero.jpg",
    "keywords": "Ayurmedix 3D rendering, packaging CGI, product visualisation, dark glass bottle render, Abox Agency",
    "brand": "Ayurmedix",
    "services": [
      "3D Product Rendering",
      "Packaging CGI"
    ],
    "industry": "Ayurvedic Healthcare",
    "schema": {
      "name": "Ayurmedix 3D Packaging Rendering Project",
      "url": "https://abox.agency/portfolio/3d/ayurmedix",
      "description": "Case study for the Ayurmedix 3D packaging rendering project covering 3D Product Rendering, and Packaging CGI.",
      "image": "https://abox.agency/assets/image/casestudy/ayurmedix-3d/ayurmedix-hero.jpg",
      "keywords": [
        "Ayurmedix",
        "3D Product Rendering",
        "Packaging CGI"
      ]
    }
  },
  "/portfolio/3d/glosense": {
    "title": "Glosense 3D Packaging Renders Case Study | Abox Agency",
    "description": "How Abox built Glosense's 3D product library — stand-up pouches and sachets modelled from print dielines, lit once, and rendered as one consistent range before the first print run.",
    "url": "https://abox.agency/portfolio/3d/glosense",
    "image": "https://abox.agency/assets/image/casestudy/glosense-3d/hero-lifestyle.jpg",
    "keywords": "Glosense 3D rendering, packaging CGI, product visualisation, pouch render, Abox Agency",
    "brand": "Glosense",
    "services": [
      "3D Product Rendering",
      "Packaging CGI"
    ],
    "industry": "Personal Care",
    "schema": {
      "name": "Glosense 3D Packaging Rendering Project",
      "url": "https://abox.agency/portfolio/3d/glosense",
      "description": "Case study for the Glosense 3D packaging rendering project covering 3D Product Rendering, and Packaging CGI.",
      "image": "https://abox.agency/assets/image/casestudy/glosense-3d/hero-lifestyle.jpg",
      "keywords": [
        "Glosense",
        "3D Product Rendering",
        "Packaging CGI"
      ]
    }
  },
  "/portfolio/3d/swara": {
    "title": "Swara Organic Dehydration 3D Packaging Case Study | Abox Agency",
    "description": "How Abox modelled Swara's rigid drawer box from the dieline, rendered four colourways with real foil and board, and animated the drawer opening before a single sample was made.",
    "url": "https://abox.agency/portfolio/3d/swara",
    "image": "https://abox.agency/assets/image/casestudy/swara-3d/hero-lifestyle.jpg",
    "keywords": "Swara Organic Dehydration 3D, packaging CGI, drawer box render, product visualisation, Abox Agency",
    "brand": "Swara Organic Dehydration",
    "services": [
      "3D Product Rendering",
      "Packaging CGI",
      "3D Animation"
    ],
    "industry": "Organic Dehydrated Foods",
    "schema": {
      "name": "Swara Organic Dehydration 3D Packaging Rendering Project",
      "url": "https://abox.agency/portfolio/3d/swara",
      "description": "Case study for the Swara Organic Dehydration 3D packaging rendering project covering 3D Product Rendering, Packaging CGI, and 3D Animation.",
      "image": "https://abox.agency/assets/image/casestudy/swara-3d/hero-lifestyle.jpg",
      "keywords": [
        "Swara Organic Dehydration",
        "3D Product Rendering",
        "Packaging CGI",
        "3D Animation"
      ]
    }
  },
  "/portfolio/3d/mia": {
    "title": "Mia Period Care 3D Packaging Case Study | Abox Agency",
    "description": "How Abox built Mia's bilingual 3D packaging library — folding cartons modelled from the dieline and rendered as studio, set and natural-light treatments from one build.",
    "url": "https://abox.agency/portfolio/3d/mia",
    "image": "https://abox.agency/assets/image/casestudy/mia-3d/hero-lifestyle.jpg",
    "keywords": "Mia 3D packaging, period care CGI, bilingual carton render, product visualisation, Abox Agency",
    "brand": "Mia",
    "services": [
      "3D Product Rendering",
      "Packaging CGI"
    ],
    "industry": "Period Care",
    "schema": {
      "name": "Mia 3D Packaging Rendering Project",
      "url": "https://abox.agency/portfolio/3d/mia",
      "description": "Case study for the Mia 3D packaging rendering project covering 3D Product Rendering, and Packaging CGI.",
      "image": "https://abox.agency/assets/image/casestudy/mia-3d/hero-lifestyle.jpg",
      "keywords": [
        "Mia",
        "3D Product Rendering",
        "Packaging CGI"
      ]
    }
  },
  "/portfolio/3d/star-scouts": {
    "title": "Star Scouts 3D Packaging Case Study | Abox Agency",
    "description": "How Abox built Star Scouts' 3D library — stand-up pouch and essential-oil sleep patches modelled, exploded and lit for listing and bedtime campaign scenes.",
    "url": "https://abox.agency/portfolio/3d/star-scouts",
    "image": "https://abox.agency/assets/image/casestudy/star-scouts-3d/hero-lifestyle.jpg",
    "keywords": "Star Scouts 3D, sleep patch CGI, packaging render, product visualisation, Abox Agency",
    "brand": "Star Scouts",
    "services": [
      "3D Product Rendering",
      "Packaging CGI"
    ],
    "industry": "Kids Sleep & Wellness",
    "schema": {
      "name": "Star Scouts 3D Packaging Rendering Project",
      "url": "https://abox.agency/portfolio/3d/star-scouts",
      "description": "Case study for the Star Scouts 3D packaging rendering project covering 3D Product Rendering, and Packaging CGI.",
      "image": "https://abox.agency/assets/image/casestudy/star-scouts-3d/hero-lifestyle.jpg",
      "keywords": [
        "Star Scouts",
        "3D Product Rendering",
        "Packaging CGI"
      ]
    }
  },
  "/portfolio/3d/aliza": {
    "title": "Aliza Perfume 3D Packaging Renders Case Study | Abox Agency",
    "description": "How Abox built Aliza Perfume's 3D attar bottle and packaging library — jewel glass, gold crown caps, and foil-stamped carton renders from one master scene.",
    "url": "https://abox.agency/portfolio/3d/aliza",
    "image": "https://abox.agency/assets/image/casestudy/aliza-3d/hero-lifestyle.jpg",
    "keywords": "Aliza Perfume 3D packaging, attar bottle render, perfume CGI, foil carton rendering, luxury bottle visualization, Abox Agency",
    "brand": "Aliza Perfume",
    "services": [
      "3D Product Rendering",
      "Packaging CGI"
    ],
    "industry": "Perfume & Attar",
    "schema": {
      "name": "Aliza Perfume 3D Packaging Rendering Project",
      "url": "https://abox.agency/portfolio/3d/aliza",
      "description": "Case study for the Aliza Perfume 3D packaging rendering project covering 3D Product Rendering, and Packaging CGI.",
      "image": "https://abox.agency/assets/image/casestudy/aliza-3d/hero-lifestyle.jpg",
      "keywords": [
        "Aliza Perfume",
        "3D Product Rendering",
        "Packaging CGI"
      ]
    }
  },
  "/portfolio/3d/my-herb": {
    "title": "My Herb 3D Packaging Case Study | Abox Agency",
    "description": "Explore the 3D packaging rendering case study for My Herb by Abox Agency — bottle modeling, realistic materials, and high-fidelity CGI visualisations.",
    "url": "https://abox.agency/portfolio/3d/my-herb",
    "image": "https://abox.agency/assets/image/casestudy/myherb-3d/slim-up-herbs.jpg",
    "keywords": "My Herb 3D, packaging CGI, cosmetic 3D renders, bottle visualization, Abox Agency",
    "brand": "My Herb",
    "services": [
      "3D Product Rendering",
      "Packaging CGI",
      "Motion Video"
    ],
    "industry": "Herbal Nutrition & Supplements",
    "schema": {
      "name": "My Herb 3D Packaging Rendering Project",
      "url": "https://abox.agency/portfolio/3d/my-herb",
      "description": "Case study for the My Herb 3D packaging rendering project covering 3D Product Rendering, Packaging CGI, and Motion Video.",
      "image": "https://abox.agency/assets/image/casestudy/myherb-3d/slim-up-herbs.jpg",
      "keywords": [
        "My Herb",
        "3D Product Rendering",
        "Packaging CGI",
        "Motion Video"
      ]
    }
  },
  "/portfolio/3d/curl-co": {
    "title": "Curl Co 3D Packaging Case Study | Abox Agency",
    "description": "Explore the 3D packaging rendering case study for Curl Co by Abox Agency — tube modeling, realistic materials, and high-fidelity CGI visualisations.",
    "url": "https://abox.agency/portfolio/3d/curl-co",
    "image": "https://abox.agency/assets/image/casestudy/curl-co-3d/curl-co-hero.avif",
    "keywords": "Curl Co 3D, packaging CGI, cosmetic 3D renders, tube visualization, Abox Agency",
    "brand": "Curl Co",
    "services": [
      "3D Product Rendering",
      "Packaging CGI"
    ],
    "industry": "Hair Care",
    "schema": {
      "name": "Curl Co 3D Packaging Rendering Project",
      "url": "https://abox.agency/portfolio/3d/curl-co",
      "description": "Case study for the Curl Co 3D packaging rendering project covering 3D Product Rendering, and Packaging CGI.",
      "image": "https://abox.agency/assets/image/casestudy/curl-co-3d/curl-co-hero.avif",
      "keywords": [
        "Curl Co",
        "3D Product Rendering",
        "Packaging CGI"
      ]
    }
  },
  "/portfolio/3d/olympus": {
    "title": "Olympus 3D Packaging Case Study | Abox Agency",
    "description": "Explore the 3D packaging rendering case study for Olympus by Abox Agency — bottle modeling, realistic materials, and high-fidelity CGI visualisations.",
    "url": "https://abox.agency/portfolio/3d/olympus",
    "image": "https://abox.agency/assets/image/casestudy/olympus-3d/olympus.avif",
    "keywords": "Olympus 3D, packaging CGI, cosmetic 3D renders, bottle visualization, Abox Agency",
    "brand": "Olympus",
    "services": [
      "3D Product Rendering",
      "Packaging CGI"
    ],
    "industry": "Cosmetics",
    "schema": {
      "name": "Olympus 3D Packaging Rendering Project",
      "url": "https://abox.agency/portfolio/3d/olympus",
      "description": "Case study for the Olympus 3D packaging rendering project covering 3D Product Rendering, and Packaging CGI.",
      "image": "https://abox.agency/assets/image/casestudy/olympus-3d/olympus.avif",
      "keywords": [
        "Olympus",
        "3D Product Rendering",
        "Packaging CGI"
      ]
    }
  },
  "/portfolio/3d/wook-wipes": {
    "title": "Wook Wipes 3D Packaging Case Study | Abox Agency",
    "description": "Explore the 3D packaging rendering case study for Wook Wipes by Abox Agency — sachet modeling, retail box renders, and high-fidelity CGI visualisations.",
    "url": "https://abox.agency/portfolio/3d/wook-wipes",
    "image": "https://abox.agency/assets/image/casestudy/woop-wipes-3d/work-wipes-hero.avif",
    "keywords": "Wook Wipes 3D, packaging CGI, wipe sachet renders, retail carton visualization, Abox Agency",
    "brand": "Wook Wipes",
    "services": [
      "3D Product Rendering",
      "Packaging CGI"
    ],
    "industry": "Personal Hygiene",
    "schema": {
      "name": "Wook Wipes 3D Packaging Rendering Project",
      "url": "https://abox.agency/portfolio/3d/wook-wipes",
      "description": "Case study for the Wook Wipes 3D packaging rendering project covering 3D Product Rendering, and Packaging CGI.",
      "image": "https://abox.agency/assets/image/casestudy/woop-wipes-3d/work-wipes-hero.avif",
      "keywords": [
        "Wook Wipes",
        "3D Product Rendering",
        "Packaging CGI"
      ]
    }
  },
  "/portfolio/3d/pourd": {
    "title": "Pour'd Cocktails 3D Packaging Case Study | Abox Agency",
    "description": "Explore the 3D beverage packaging rendering case study for Pour'd Cocktails by Abox Agency — bottle modeling, liquid refraction, glassware, and high-fidelity CGI visualisations.",
    "url": "https://abox.agency/portfolio/3d/pourd",
    "image": "https://abox.agency/assets/image/casestudy/pourd-3d/pourd-hero.jpg",
    "keywords": "Pour'd Cocktails 3D, beverage packaging CGI, cocktail 3D renders, bottle visualization, Abox Agency",
    "brand": "Pour'd Cocktails",
    "services": [
      "3D Product Rendering",
      "Beverage CGI",
      "Motion Video"
    ],
    "industry": "Ready-to-Drink Cocktails",
    "schema": {
      "name": "Pour'd Cocktails 3D Packaging Rendering Project",
      "url": "https://abox.agency/portfolio/3d/pourd",
      "description": "Case study for the Pour'd Cocktails 3D packaging rendering project covering 3D Product Rendering, Beverage CGI, and Motion Video.",
      "image": "https://abox.agency/assets/image/casestudy/pourd-3d/pourd-hero.jpg",
      "keywords": [
        "Pour'd Cocktails",
        "3D Product Rendering",
        "Beverage CGI",
        "Motion Video"
      ]
    }
  },
  "/portfolio/3d/ras": {
    "title": "RAS Luxury Skincare 3D Packaging Case Study | Abox Agency",
    "description": "Explore the 3D beauty rendering case study for RAS Luxury Skincare by Abox Agency — bottle modeling, gold shaders, open jars, lipsticks, lip oils, and high-fidelity CGI visualisations.",
    "url": "https://abox.agency/portfolio/3d/ras",
    "image": "https://abox.agency/assets/image/casestudy/ras-3d/ras-hero.jpg",
    "keywords": "RAS Luxury Skincare 3D, beauty packaging CGI, cosmetic 3D renders, skincare visualization, lipstick CGI, lip oil 3D, Abox Agency",
    "brand": "RAS Luxury Skincare",
    "services": [
      "3D Product Rendering",
      "Cosmetic CGI",
      "Motion Video"
    ],
    "industry": "Luxury Skincare & Beauty",
    "schema": {
      "name": "RAS Luxury Skincare 3D Packaging Rendering Project",
      "url": "https://abox.agency/portfolio/3d/ras",
      "description": "Case study for the RAS Luxury Skincare 3D packaging rendering project covering 3D Product Rendering, Cosmetic CGI, and Motion Video.",
      "image": "https://abox.agency/assets/image/casestudy/ras-3d/ras-hero.jpg",
      "keywords": [
        "RAS Luxury Skincare",
        "3D Product Rendering",
        "Cosmetic CGI",
        "Motion Video"
      ]
    }
  },
  "/portfolio/3d/nyra": {
    "title": "Nyra 3D Beauty Tech Packaging Case Study | Abox Agency",
    "description": "Explore the 3D beauty tech rendering case study for Nyra by Abox Agency — device modeling, LED emission shaders, and high-fidelity CGI visualisations.",
    "url": "https://abox.agency/portfolio/3d/nyra",
    "image": "https://abox.agency/assets/image/casestudy/nyra-3d/nyra-hero.webp",
    "keywords": "Nyra 3D, beauty tech CGI, device 3D renders, IPL handset visualization, LED wand CGI, Abox Agency",
    "brand": "Nyra",
    "services": [
      "3D Product Rendering",
      "Beauty Tech CGI"
    ],
    "industry": "Beauty Tech Devices",
    "schema": {
      "name": "Nyra 3D Packaging Rendering Project",
      "url": "https://abox.agency/portfolio/3d/nyra",
      "description": "Case study for the Nyra 3D packaging rendering project covering 3D Product Rendering, and Beauty Tech CGI.",
      "image": "https://abox.agency/assets/image/casestudy/nyra-3d/nyra-hero.webp",
      "keywords": [
        "Nyra",
        "3D Product Rendering",
        "Beauty Tech CGI"
      ]
    }
  }
};